app = angular.module('harriApp');

app.factory('settingsFactory', ["httpHelper", "$q", "JobAppAPIs", "hUser", "$filter", "userPermissions", function (httpHelper, $q, JobAppAPIs, hUser, $filter, userPermissions) {
    var APIs = {
        savingReferences : false,
        userPrivacy: function() {
            return httpHelper.g('user/privacy');
        },
        deleteLocations: function(locations) {
          for (var i in locations) {
            httpHelper.g("user_location/delete/" + locations[i]);
          }
        },
        deleteAdmins: function(brandId, usersIds) {
          for (var i in usersIds) {
            httpHelper.p("brand_admin_delete", {
              brand_id: brandId,
              user_id: usersIds[i]
            });
          }
        },
        brandBasicInformation: function(brand_id) {
            return httpHelper.g('brand/basic_information/'+brand_id);
        },
        /**
         * Get brand admins (users information)
         * @param brand_id
         * @returns promise
         */
        brandUsersInformation: SettingsAPI.getBrandAdmins,
        newBrandPaymentMethod: function (formData) {
            var defer = $q.defer();
            StripeAPI.addPaymentMethod(formData.brand_id, formData.credit_card).then(function (data) {
                defer.resolve(data);
            }, function (err) {
                if (err && err.data === 'BILLING_MANAGEMENT_NOT_ALLOWED') {
                    hAlert(
                        $filter("translate")("Something went wrong"),
                        $filter("translate")("Something went wrong please check your account settings.")
                    );
                }
                defer.reject(err);
            });
            return defer.promise;
        },
        saveUsersManagement: function(formData) {
          var admins = formData.admins;
          var brandId = formData.brand_id;

          var promises = [];

          // handle adding all admins (save changes)
          for (var i in admins) {
            var promise;
            var dataObj = {};
            dataObj.hide_docs = !admins[i]['view_docs'];
            dataObj.payroll_disabled = !admins[i]['payroll_enabled'];
            dataObj.edit_offer = admins[i]['edit_offer'];
            dataObj.onboarding_admin = admins[i]['onboarding_admin'];
            dataObj.job_post = admins[i]['job_post'];
            if (admins[i].new_admin) {
              //convert brandId to number instead of string
              dataObj.brand_ids = [parseInt(brandId)];
              if (admins[i].new_user) {
                // Adding admin - non existing user
                dataObj.email = admins[i].email;
                dataObj.first_name = admins[i].first_name;
                dataObj.last_name = admins[i].last_name;
                dataObj.password = admins[i].password;
                promise = httpHelper.put("brand_admin", dataObj);
              }
              else {
                // Adding admin - existing user
                dataObj.user_email = admins[i].email;
                promise = httpHelper.put("brand_admin", dataObj);
              }
            }
            else {
                if (formData.isEditAdmin && admins[i].id != hUser.getUser().id) {
                    dataObj.brand_id = parseInt(brandId);
                    dataObj.user_id = parseInt(admins[i].id);
                    promise = httpHelper.p("admin_services", dataObj);
                }
            }
            if (promise) promises.push(promise);
          }

          var deferred = $q.defer();

          $q.all(promises).then(function (res) {
              deferred.resolve(res);
          }, (err) => {
              if (err.status === 400 || err.status === 403) {
                  if (err.status === 403) {
                      hAlert("Error", $filter("translate")("This email account is missing a key information on Harri, Please have them login with this email first to update their info."));
                  } else {
                      if (typeof (err.data.data) == 'object') {
                          hAlert("Error", err.data.data[0].error);
                      } else {
                          hAlert("Error", err.data.data);
                      }
                  }
                  deferred.reject([err.data]);
              } else {
                  deferred.reject(err);
              }
          });

          return deferred.promise;
        },
        savePrivacy: function(formData) {


            var defer = $q.defer();

            var promises = {};

            if (formData.old_password) {
                promises.changePassword = hLoginManager.changePassword(formData.old_password, formData.new_password);
            }

            if (formData.canEditPublicPrivate) {
                formData.is_public = formData.is_public === "true" || formData.is_public === true;

                promises.privacy = httpHelper.p('user/privacy', {
                    is_public: formData.is_public
                });
            }

            $q.all(promises).then(function(res) {
                if(res.changePassword && res.changePassword.success) {
                    var changePassword = res.changePassword;
                    // Insufficient Session Expiration fix
                    hLoginManager.invalidateUserTokens().then(function(){
                        hLoginManager.regenerateUserTokens().then(function () {
                            defer.resolve(changePassword);
                        })
                    })

                } else if (res.changePassword && res.changePassword.error) {
                    defer.reject(res.changePassword.error)
                } else {
                    defer.resolve(res.privacy);
                }
            }, function(errors) {
                defer.reject(errors);
            });


            return defer.promise;
        },
        userRefrences:[],
        getUserRefrences: function() {
            var defer = $q.defer();

            var p = httpHelper.g('reference');

            APIs.userRefrences = [];

            p.then(function(res) {
                if(res.data.status_code == 200) {
                    for(var k in res.data.data) {
                        for(var i in res.data.data[k]) {
                            var ref = res.data.data[k][i];
                            APIs.userRefrences.push(keepAttrs(angular.copy(ref), ['name', 'email', 'phone', 'brand_name', 'id']));
                        }
                    }

                    defer.resolve(APIs.userRefrences);
                } else {
                    defer.reject(APIs.userRefrences);
                }
            }, function() {
                defer.reject(APIs.userRefrences);
            });

            return defer.promise;
        },
        editReferences: function(formData) {
            var self = this;

            var defer = $q.defer();

            if (self.savingReferences) {
                defer.resolve();
                return defer.promise;
            }

            self.savingReferences = true;

            var promises = [];

            var toEit = [];
            var toCreate = [];
            var toDelete = {};


            for(var k in formData) {
                if(formData[k].id) {
                    toDelete[formData[k].id] = false;

                    formData[k].reference_id = formData[k].id;
                    delete formData[k].id;

                    toEit.push(formData[k]);
                    promises.push( httpHelper.p('reference', formData[k]));

                } else {
                    toCreate.push(formData[k]);
                    promises.push( httpHelper.put('reference', [formData[k]]));
                }
            }

            var userData = APIs.userRefrences;
            //prepare delete items
            for(var i in userData) {
                var Ref = userData[i];

                if(toDelete[Ref.id]!==false) {
                    promises.push( httpHelper.d('reference/' + Ref.id) )
                } else if(toDelete[Ref.id]===false) {
                    delete toDelete[Ref.id];
                }
            }


            $q.all(promises).then(function(all) {
                self.savingReferences = false;
                defer.resolve();
            }, function(all) {
                self.savingReferences = false;
                defer.resolve();
            });

            return defer.promise;
        },

        userWorkhistory:[],
        getUserWorkHistory: function() {
            var defer = $q.defer();

            var p = httpHelper.g('work_history');

            APIs.userWorkhistory = [];

            p.then(function(res) {
                if(res.data.status_code == 200) {

                    if(res.data.data.first_job && res.data.data.first_job == true) {
                        defer.resolve({first_job: true});
                        return defer.promise;
                    }

                    for(var k in res.data.data) {

                        var workHistoryItem = res.data.data[k];
                        var workHistoryAttrs = {};

                        //work id
                        if(workHistoryItem.Work.id) {
                            workHistoryAttrs.id = workHistoryItem.Work.id;
                        }

                        //brand name
                        if(workHistoryItem.Work.Brand.name) {
                            workHistoryAttrs.brand = {label:workHistoryItem.Work.Brand.name, value:{brand_id: workHistoryItem.Work.Brand.id}};
                        }


                        //description
                        if(workHistoryItem.Work.description) {
                            workHistoryAttrs.description = workHistoryItem.Work.description;
                        }

                        //end_date
                        if(workHistoryItem.Work.end_date) {
                            workHistoryAttrs.end_date = workHistoryItem.Work.end_date;
                        }

                        //start_date
                        if(workHistoryItem.Work.start_date) {
                            workHistoryAttrs.start_date = workHistoryItem.Work.start_date;
                        }

                        //I still_work_here case
                        if(!workHistoryItem.Work.end_date && workHistoryItem.Work.start_date) {
                            workHistoryAttrs.still_work_here = true;
                        }

                        //position
                        if(workHistoryItem.Work.Position) {
                            var position = workHistoryItem.Work.Position;
                            workHistoryAttrs.position_id = {name: position.name, value: position.id};
                        }

                        //custom position
                        if(workHistoryItem.Work.custom_position) {
                            var l = workHistoryItem.Work.custom_position;
                            workHistoryAttrs.position_id = {name: l, value:{custom_position:l}};
                        }

                        //Address Id
                        if(workHistoryItem.Work.Brand && workHistoryItem.Work.Brand.Location) {
                            var gformatted_address = workHistoryItem.Work.Brand.Location.formatted_address;
                            var googleLocationId = workHistoryItem.Work.Brand.Location.id;
                            workHistoryAttrs.google_location = {label: gformatted_address, value: {id: googleLocationId}};
                        }
                        APIs.userWorkhistory.push(workHistoryAttrs);

                    }

                    defer.resolve(APIs.userWorkhistory);
                } else {
                    defer.reject(APIs.userWorkhistory);
                }
            }, function() {
                defer.reject(APIs.userWorkhistory);
            });

            return defer.promise;
        },

        editWorkHistories: function(formData) {
            var promises = [];
            var ids = [];
            //First_job
            if(formData.first_job) {
                return JobAppAPIs.createWorkHistory(formData);
            }

            for(var k in formData) {
                if(formData[k].id) {
                    //ids to compare with original work history
                    ids.push(formData[k].id);
                    //edit
                    promises.push( APIs.editWorkHistory(formData[k]) );
                } else {
                    //save new work history
                    promises.push( JobAppAPIs.createWorkHistory(formData[k]) );
                }
            }

            //delete work histories
            var toDelete = [];

            //search for the current ids in the original work histories
            for(var k in APIs.userWorkhistory) {
                if(APIs.userWorkhistory[k].id && !_.contains(ids, APIs.userWorkhistory[k].id)) {
                    toDelete.push(APIs.userWorkhistory[k].id);
                }
            }
            promises.push( APIs.deleteWorkHistories(toDelete) );

            return $q.all(promises);
        },

        editWorkHistory: function(formData) {
            var promises = [];

            promises.push( APIs.editWorkHistoryBrand(formData) );
            promises.push( APIs.editWorkHistoryDetails(formData) );

            return $q.all(promises);
        },

        editWorkHistoryBrand: function(formData) {
            var brandObj = {};

            if(formData.id) {
                formData.work_id = formData.id;
            }

            brandObj = keepAttrs(angular.copy(formData), ['work_id','brand_name', 'google_place', 'location_id', 'brand_id']);

            return httpHelper.p('edit_work_history', brandObj);
        },

        editWorkHistoryDetails: function(formData) {
            var brandObj = {};

            if(formData.id) {
                formData.work_id = formData.id;
            }

            brandObj = removeAttrs(angular.copy(formData), ['brand_name', 'google_place', 'location_id', 'brand_id']);

            if(!brandObj.end_date) {
                brandObj.end_date = "";
            }

            return httpHelper.p('work_history', brandObj);
        },

        deleteWorkHistories: function(ids) {
            var promises = [];

            for(var k in ids) {
                promises.push( httpHelper.d('work_history/' + ids[k]) );
            }

            return $q.all(promises);
        },


        //education
        userEducation:[],
        getUserEducation: function() {
            var defer = $q.defer();

            var userId = hUser.data.user.id;
            var p = httpHelper.g('user_education/' + userId);

            APIs.userEducation = [];

            p.then(function(res) {
                if(res.data.status_code == 200) {

                    for(var k in res.data.data) {

                        var educationItem = res.data.data[k].UserEducation;
                        var educationAttrs = {};


                        if(educationItem.Institution.id) {
                            educationAttrs.institute = {label:educationItem.Institution.name, institution_id: educationItem.Institution.id};
                        }

                        //education id
                        if(educationItem.id) {
                            educationAttrs.education_id = educationItem.id;
                            educationAttrs.id = educationItem.id;
                        }

                        //degree_id
                        if(educationItem.DegreeLookup && educationItem.DegreeLookup.degree) {
                            educationAttrs.degree_id = educationItem.DegreeLookup;
                        }

                        //DisciplineLookup
                        if(educationItem.DisciplineLookup && educationItem.DisciplineLookup.name) {
                            educationAttrs.discipline = educationItem.DisciplineLookup.name;
                        }

                        //end_date
                        if(educationItem.end_date) {
                            educationAttrs.end_date = educationItem.end_date;
                        }

                        //start_date
                        if(educationItem.start_date) {
                            educationAttrs.start_date = educationItem.start_date;
                        }

                        //I still_work_here case
                        if(!educationItem.end_date && educationItem.start_date) {
                            educationAttrs.still_in_school = true;
                        }

                        APIs.userEducation.push(educationAttrs);
                    }

                    defer.resolve(APIs.userEducation);
                } else {
                    defer.reject(APIs.userEducation);
                }
            }, function() {
                defer.reject(APIs.userEducation);
            });

            return defer.promise;
        },

        editEducations: function(formData) {
            var promises = [];
            var ids = [];

            for(var k in formData) {
                if(formData[k].id) {
                    //ids to compare with original work history
                    ids.push(formData[k].id);

                    //edit
                    promises.push( APIs.editEducation(formData[k]) );
                } else {
                    //save new work history
                    promises.push( JobAppAPIs.saveEducation(formData[k]) );
                }
            }

            //delete work histories
            var toDelete = [];

            //search for the current ids in the original work histories
            for(var k in APIs.userEducation) {
                if(APIs.userEducation[k].id && !_.contains(ids, APIs.userEducation[k].id)) {
                    toDelete.push(APIs.userEducation[k].id);
                }
            }
            promises.push( APIs.deleteEducations(toDelete) );

            return $q.all(promises);
        },

        editEducation: function(formData) {
            var promises = [];

            promises.push( APIs.editEducationInstituatioName(formData) );
            promises.push( APIs.editEducationDetails(formData) );

            return $q.all(promises);
        },

        editEducationInstituatioName: function(formData) {
            var brandObj = {};

            brandObj = keepAttrs(angular.copy(formData), ['institution_name', 'google_place', 'institution_id', 'education_id']);

            return httpHelper.p('edit_user_education', brandObj);
        },

        editEducationDetails: function(formData) {
            var extended_data = removeAttrs(angular.copy(formData), ['institution_name', 'google_place', 'id', 'still_in_school']);

            return httpHelper.p('user_education', extended_data);
        },

        deleteEducations: function(ids) {
            var promises = [];

            for(var k in ids) {
                promises.push( httpHelper.d('user_education/' + ids[k]) );
            }

            return $q.all(promises);
        },

        saveBrandReviewsSettings: function(formData) {

            var brandId = formData.brand_id;
            var payload = {
                "period": formData.reviewPeriod,
                "recurring": formData.recuring,
                "reminder_enabled": formData.reviewDueReminder
            };
            return SettingsAPI.saveBrandReviewsSettings(brandId, payload);
        }


    };
    return APIs;
}]);

app.directive('basicInformationDirective', ["hFormReference", "$alert", "registrationApi", "$state", "hUser", "positionsDataService", "$modal", "brandServices", function(hFormReference, $alert, registrationApi, $state, hUser, positionsDataService, $modal, brandServices) {
    return {
        link: function(scope, element) {

            /* Handle maximum charcter length dynimcaly from the UserModl
             */
            scope.isHallAndWoodhouseExternalAuth = hUser.isHallAndWoodhouseExternalAuth();
            scope.isRadissonExternalAuth = hUser.isRadissonExternalAuth();
            scope.isMCDExternalAuth = hUser.isMCDExternalAuth();
            scope.enablePhoneValidation = false;
            scope.enableEmailValidation = false;
            scope.firstNameMaxLength = 32;
            scope.lastNameMaxLength = 32;
            scope.phoneSuccess = false;
            scope.formSavedSuccessfully = false;
            scope.isWebClient = (hUser.getUserContext() && hUser.getUserContext().brand_type === 'brand');
            scope.userType = hUser.getUserType();
            scope.emailEligibility;

            scope.basicInfoCompleted = function () {
                if (!scope.formSavedSuccessfully) {
                    if ($state.is('appLayout.harriSH.editprofile')) {
                        if (hUser.isEmployer()) {
                            brandServices.check(brandServices.SERVICES.INTERVIEW_V2, hUser.getEntryMode().brand_id, true)
                                .then(function (isInterviewV2ServiceEnabled) {
                                    if (isInterviewV2ServiceEnabled) {
                                        $state.go('appLayout.harriSH.editprofile', {view: 'sync_calendar'});
                                    } else {
                                        $state.go('appLayout.harriSH.editprofile', {view: 'security_privacy'});
                                    }
                                });
                        } else {
                            $state.go('appLayout.harriSH.editprofile', {view: 'security_privacy'});
                        }
                    } else {
                        $state.go('appLayout.harriSH.settings.section', {view: 'security_privacy'});
                    }
                }
            };

            scope.resetFormFlags = function(){
                delete scope.phoneSuccess;
                delete scope.dataLoaded;
                delete scope.success;
                scope.phoneVerifiedMessage = "";
            }

            scope.onPhoneChanges = function () {
                if (scope.origionalPhone !== window.intlTelInputUtils.formatNumber(scope.data.basic_info.phone)) {
                    scope.data.basic_info.phone_status = 'NOT_VERIFIED';
                } else {
                    scope.data.basic_info.phone_status = scope.origionalPhoneStatus;
                }
                scope.enablePhoneValidation = true;
                scope.phoneVerifiedMessage = '';
                scope.phoneExsit = '';
            };

            scope.requestPhoneVerification = function () {
                if (scope.isPhonePending) {
                    return;
                }
                scope.isPhonePending = true;
                scope.phoneSuccess = false;

                UserAPI.sendVerificationLink('PHONE')
                    .then(function () {
                        scope.origionalPhoneStatus = 'PENDING_VERIFICATION';
                        scope.phoneSuccess = true;
                    })
                    .catch(function (err) {
                        console.error(err);
                        if(err.status_code == 422) {
                            scope.phoneVerifiedMessage = 'Phone is already verified';
                        }
                        if(err.status_code == 400) {
                            if(err.data.code==="USER_MAX_RETRIES_REACHED"){
                                scope.phoneVerifiedMessage = err.data.message;
                            }
                            else{
                                scope.phoneVerifiedMessage = 'Phone is verified for another account';
                            }
                        }
                    })
                    .finally(function () {
                        scope.$digest();
                        scope.isPhonePending = false;
                    });
            };

            scope.requestEmailVerification = function () {
                if (scope.isEmailPending) {
                    return;
                }
                scope.isEmailPending = true;
                scope.emailSuccess = false;

                UserAPI.sendVerificationLink('EMAIL')
                    .then(function (response) {
                        if (response.status) {
                            scope.emailSuccess = true;
                            HNotifications.show({
                                title: $filter("translate")("An email has been sent to your Email! Please check your inbox"),
                                desc: '',
                                icon: "fa-check",
                                type: "success",
                                timeout: 4000
                            });
                        } else {
                            HNotifications.show({
                                title: $filter("translate")("Something went wrong! Please try again later"),
                                desc: '',
                                icon: "fa-times-circle",
                                type: "danger",
                                timeout: 4000
                            });
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                        hAlert($filter("translate")("Error"), $filter("translate")("Something Went Wrong"));
                    })
                    .finally(function () {
                        scope.$digest();
                        scope.isEmailPending = false;
                    });
            };

            scope.openVerificationModal = function () {
                scope.success = false;
                $modal({
                    controller: 'PhoneVerificationByEmployeeModal',
                    controllerAs: '$ctrl',
                    templateUrl: '../modules/settings/modals/phone-verification-by-employee/phone-verification-by-employee.modal.html',
                    show: true,
                    resolve: {
                        modalData: function () {
                            return {
                                 phone: scope.phone
                            }
                        },
                        onSave: function () {
                            return function () {
                                scope.success = true;
                                scope.origionalPhoneStatus = 'VERIFIED';
                            };
                        }
                    }
                });
            };

            var userData = {};

            scope.basicInfoReset = function() {
                //reset form
                //scope.reset();

                //load custom data
                scope.loadData(userData);
            };

            hFormReference.current(element, {
                beforeActive: function(scope) {
                    const initRecaptcha = () => {
                        scope.loadRecaptcha = true;

                        hRecaptchaUtil.initRecaptchaScript()
                            .then(() => {
                                scope.loadRecaptcha = false;
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    };

                    initRecaptcha();

                    scope.employerUser = hUser.isEmployer();

                    if (!scope.positions || scope.positions.length == 0) {
                        positionsDataService.getSystemPositionsFlat().then(function (positions) {
                            for (var i in positions) {
                                positions[i].value = positions[i].id;
                            }
                            scope.positions = positions;
                        });
                    }
                    UserAPI.checkChangeEmailEligibility()
                        .then( function (res){
                            scope.emailEligibility = JSON.stringify(res);
                            var errMsgCode = res.reason.code;
                            scope.editPrimaryEmailAddreessEnabled = !(errMsgCode === 'BLOCKED_BY_SELF_EMAIL_EDIT_SETTINGS' || errMsgCode === 'SELF_EMAIL_EDIT_SERVICE_NOT_ACTIVATED');
                            scope.$digest();
                        });

                    var promise = scope.remoteLoad(undefined, undefined, ['first_name', 'last_name', 'slug', 'email', 'phone', 'positions', 'email_status', 'phone_status', 'can_edit_first_name_and_last_name']);
                    scope.dataLoaded = false;
                    promise.then(function(res) {
                        scope.dataLoaded = true;
                        scope.success = false;

                        userData = res.data.data;
                        scope.emailEditDisabled = !!userData.email;
                        scope.nameEditDisabled = !userData.can_edit_first_name_and_last_name;
                        scope.email = userData.email;
                        scope.phone = userData.phone;
                        scope.email_status = userData.email_status;
                        scope.phone_status = userData.phone_status;
                        scope.origionalPhone = userData.phone;
                        scope.origionalPhoneStatus = userData.phone_status;

                        // Some users don't have first_name and last_name, force them to fill these information in the settings
                        if (!userData.first_name || !userData.last_name) {
                            scope.showMissingInfo = true;
                        }

                        scope.data.basic_info.newslug = userData.slug;
                    });


                    return promise;
                },
                beforeSave: function(formData, valid) {
                    //scope.resetRemoteValidation();
                    if(formData.positions && formData.positions.length > 0) {
                        for(var i in formData.positions) {
                            formData.positions[i] = {id: formData.positions[i].id};
                        }
                    } else if (formData.positions) {
                        delete formData.positions;
                    }
                    formData.slug = formData.newslug;

                    formData.phone = window.intlTelInputUtils.formatNumber(formData.phone);

                    return formData;
                },
                afterSave: function(data, formData, requestStatus) {
                    if (data.status_code == 200) {
                        var gettingData = scope.remoteLoad(undefined, undefined, ['first_name', 'last_name', 'slug', 'email', 'phone', 'positions', 'email_status', 'phone_status']);
                        gettingData.then(function(res) {
                            scope.phone = res.data.data.phone;
                            scope.origionalPhone = res.data.data.phone;
                            scope.origionalPhoneStatus = 'NOT_VERIFIED';
                        });
                        if (formData.phone !== scope.phone) {
                            scope.formSavedSuccessfully = true;
                            scope.resetFormFlags();
                            hAlert({
                                title: $filter("translate")("Phone number has been edited"),
                                text: $filter("translate")("Your phone number has been edited, click on 'Verify' to receive a verification code. After verification, you will start login with the new phone number"),
                                button: {
                                    text: $filter("translate")("Close")
                                }
                            });
                        }

                      hUser.init();
                    } else if (data.status_code == 422) {
                        if (data.data.code === "EDITING_FIRST_AND_LAST_NAME_IS_BLOCKED") {
                            hAlert({
                                title: $filter("translate")("Error"),
                                text: $filter("translate")("You can't change your First Name and Last Name, please reach out to your manager to do so."),
                                button: {
                                    text: $filter("translate")("Close")
                                }
                            });
                        }
                    }
                }
            }).then(function(formObj) {

            })

        }
    }
}]);

app.directive('userExist', customValidatorDirectiveFunc);

customValidatorDirectiveFunc.$inject = ['$q'];

function customValidatorDirectiveFunc($q) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.invalidPhone = function (modelValue, viewValue) {
                var defer = $q.defer();
                if (viewValue && (attrs.phoneNumber !== viewValue) && (attrs.phoneStatus == 'NOT_VERIFIED' || attrs.phoneStatus == "" || attrs.phoneStatus == 'PENDING_VERIFICATION')) {
                    DashboardAPI.checkUserRegistrationByPhone(viewValue).then(function (result) {
                        if (result.on_harri && result.user_info) {
                            scope.phoneExsit = $filter("translate")("Phone already exists");
                        } else {
                            scope.phoneExsit = '';
                        }
                        defer.resolve(true);
                    });
                }
                else {
                    defer.resolve(false);
                }
                return defer.promise;
            };
        }
    }
}

app.directive('customEmailExist', customValidatorDirective);

customValidatorDirective.$inject = ['$q'];

function customValidatorDirective($q) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.existEmail = function (modelValue, viewValue) {
                var defer = $q.defer();
                if (viewValue && (attrs.emailStatus == 'NOT_VERIFIED' || attrs.emailStatus == "" || scope.enableEmailValidation)) {
                    DashboardAPI.checkUserRegistration(viewValue).then(function (result) {
                        if (result.on_harri && result.user_info) {
                            scope.emailExistMessage = $filter("translate")("Email already exists");
                            defer.reject();
                        } else {
                            scope.emailExistMessage = '';
                            defer.resolve();
                        }
                    });
                }
                return defer.promise;
            };
        }
    }
}

/* =============================================================*/
/* Security & Privacy Directive.
 /* =============================================================*/
app.directive('syncCalendarDirective', ["hFormReference", "$state", "hUser", function(hFormReference, $state, hUser) {
    return {
        link: function(scope, element) {

            scope.disconnectGoogleCalendar = function (){
                InterviewV2API.syncCalendar('GOOGLE', false)
                    .then(function (response) {
                        delete scope.data.calendar_settings.googleCalendar;
                        delete scope.data.calendar_settings.googleCalendarEmail;
                        scope.$digest();
                    }, function () {
                        hAlert("Error" + "!", $filter("translate")("Something went wrong, Please try again."));
                    });
            };

            scope.resetSyncCalendarSettings = function () {
                scope.data.calendar_settings.isICSEnabled = $.grep(scope.data.calendar_settings.calendars, function (e) {
                    return e.type == 'ICS'
                })[0] ? true : false;
            };

            scope.onSuccessGoogleCalendar = function () {
                InterviewV2API.getCalendarsSettings()
                    .then(function (CalendarsSettings) {
                        scope.data.calendar_settings.googleCalendar = $.grep(CalendarsSettings.calendars, function (e) {
                            return e.type == 'GOOGLE'
                        })[0];
                        if (scope.data.calendar_settings.googleCalendar && scope.data.calendar_settings.googleCalendar.google_calendar_setting) {
                            scope.data.calendar_settings.googleCalendarEmail = scope.data.calendar_settings.googleCalendar.google_calendar_setting.email;
                        }
                        scope.data.calendar_settings.googleCalendarState = CalendarsSettings.url ? CalendarsSettings.url[1] : null;
                        scope.$apply();
                    });
            };

            scope.loadSyncSettings = function () {
                scope.isLoading = true;
                InterviewV2API.getCalendarsSettings()
                    .then(function (CalendarsSettings) {
                        scope.data.calendar_settings = CalendarsSettings;

                        scope.data.calendar_settings.isICSEnabled = $.grep(CalendarsSettings.calendars, function (e) {
                            return e.type == 'ICS'
                        })[0] ? true : false;
                        scope.data.calendar_settings.googleCalendar = $.grep(CalendarsSettings.calendars, function (e) {
                            return e.type == 'GOOGLE'
                        })[0];
                        if (scope.data.calendar_settings.googleCalendar && scope.data.calendar_settings.googleCalendar.google_calendar_setting) {
                            scope.data.calendar_settings.googleCalendarEmail = scope.data.calendar_settings.googleCalendar.google_calendar_setting.email;
                        }
                        scope.data.calendar_settings.googleCalendarState = CalendarsSettings.url ? CalendarsSettings.url[1] : null;
                        scope.data.user_info = {
                            "first_name": hUser.data.user.first_name,
                            "last_name": hUser.data.user.last_name
                        };
                        scope.isLoading = false;
                        scope.$apply();
                    });
            };

            hFormReference.current(element, {
                beforeActive: function() {
                    scope.loadSyncSettings();
                },
                beforeSave: function(formData, valid) {
                    var originalICSStatus = $.grep(scope.data.calendar_settings.calendars, function(e){ return e.type == 'ICS' })[0] ? true : false;
                    if( scope.data.calendar_settings.isICSEnabled != originalICSStatus){
                        InterviewV2API.syncCalendar('ICS', scope.data.calendar_settings.isICSEnabled)
                            .then(function (response) {

                                $state.go('appLayout.harriSH.editprofile', {view: 'security_privacy'});

                                scope.$digest();
                            }, function () {
                                hAlert("Error" + "!", $filter("translate")("Something went wrong, Please try again."));
                            });

                    }
                    else{
                        $state.go('appLayout.harriSH.editprofile', {view: 'security_privacy'});
                    }
                    return formData;
                },
            }).then(function(formObj) {

            })

        }
    }
}]);


/* =============================================================*/
/* Security & Privacy Directive.
/* =============================================================*/
app.directive('securityPrivacyDirective', ["hFormReference", "$alert", "registrationApi", "$state", "$q", "settingsFactory", "httpHelper", "$timeout", "hUser", "brandServices",
    function(hFormReference, $alert, registrationApi, $state, $q, settingsFactory, httpHelper,$timeout, hUser, brandServices) {
    return {
        link: function(scope, element) {

            scope.isTLMode = $state.is("appLayout.schedule.editprofile");
            scope.isShowMFAView = false;
            scope.emailIsVerified = false;
            scope.userType = hUser.getUserType();

            scope.init = function () {
                SettingsAPI.loadPersonalInformation()
                    .then(function (res) {
                        scope.verification_email = res.email;
                        scope.data.security_privacy.canEditPublicPrivate = res.can_edit_is_public_flag || false;
                        scope.emailIsVerified = res.email && res.email_status === 'VERIFIED';
                    })
                    .catch(function (err) {
                        console.error(err);
                    })
                    .finally(function () {
                        scope.$digest();
                    });
            }
            scope.init();

            scope.securityPrivacyCompleted = function() {
                if (!scope.isTLMode) {
                    if ($state.is('appLayout.harriSH.editprofile')) {
                        $state.go('appLayout.harriSH.editprofile', {view: 'time_geography'});
                    } else {
                        $state.go('appLayout.harriSH.settings.section', {view: 'time_geography'});
                    }
                }
                else {
                    if (scope.data.security_privacy.old_password) {
                        HNotifications.show({
                            title: self.$filter('translate')("Success"),
                            desc: self.$filter('translate')("Password changed successfully"),
                            icon: "fa-check-circle",
                            type: "success"
                        });
                        scope.securityPrivacyReset();
                    }
                }
            };

            var is_public = true;
            scope.isRadissonExternalAuth = hUser.isRadissonExternalAuth();

            scope.securityPrivacyReset= function() {
                var ignoreFields = [];
                //ignoreFields['is_public'] = true;
                scope.reset(ignoreFields);
                scope.resetRemoteValidation();
                $timeout(function (){
                    scope.$apply(function() {
                        scope.data.security_privacy.is_public = is_public;
                        scope.data.security_privacy.new_password = "";
                        scope.data.security_privacy.old_password = "";
                        scope.data.security_privacy.confirm_new_password = "";
                    });
                });
            };

            scope.handleError = function (err) {
                if (!err) {
                    return '';
                }
                if (err === 'Access Token does not have required scopes') {
                    return 'Unable to change the password for this account. For more details please contact support@harri.com';
                } else {
                    return err;
                }
            };

            scope.sendCodeVerification = function () {
                UserAPI.sendVerificationLink('EMAIL')
                    .then(function (response) {
                        if (response.status) {
                            HNotifications.show({
                                title: $filter("translate")("An email has been sent to your Email! Please check your inbox"),
                                desc: '',
                                icon: "fa-check",
                                type: "success",
                                timeout: 4000
                            });
                        } else {
                            HNotifications.show({
                                title: $filter("translate")("Something went wrong! Please try again later"),
                                desc: '',
                                icon: "fa-times-circle",
                                type: "danger",
                                timeout: 4000
                            });
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                        hAlert($filter("translate")("Error"), $filter("translate")("Something Went Wrong"));
                    });
            }

            hFormReference.current(element, {
                beforeActive: function(scope) {
                    var defer = $q.defer();
                    var promises = {};
                    promises['userPrivacy'] =  settingsFactory.userPrivacy();
                    promises['mfaAvailableMethods'] = UserAPI.getAvailableMfaMethods();
                    promises['userInfo'] = SettingsAPI.loadPersonalInformation()

                    $q.all(promises).then(function (res) {
                        scope.isSocialLogin = res['userInfo'].social_login;
                        scope.isMFAServiceEnabled = res['mfaAvailableMethods'].length > 0;
                        if (res['userPrivacy'].data && res['userPrivacy'].data.data) {
                            if (res['userPrivacy'].data.data.is_public === false) {
                                scope.data.security_privacy.is_public = false;
                            } else {
                                scope.data.security_privacy.is_public = true;
                            }

                            is_public = scope.data.security_privacy.is_public;
                        }
                        scope.data.security_privacy.canEditPublicPrivate = res.userInfo?.can_edit_is_public_flag || false;
                        defer.resolve();
                    });

                    scope.data.security_privacy.canEditPublicPrivate = false;
                    scope.data.security_privacy.new_password = "";
                    scope.data.security_privacy.old_password = "";
                    scope.data.security_privacy.confirm_new_password = "";

                    return defer.promise;
                }
            }).then(function(formObj) {

            })

            scope.showMFA = function(isShowMFA) {
                scope.isShowMFAView = isShowMFA;
                scope.$digest();
            }

        }
    }
}]);



/* =====================================================*/
/* Notification Directive for user email Notifications
/* =====================================================*/
app.directive('notificationsDirective', ["hFormReference", "httpHelper", "registrationApi", "$state", "$q", "settingsFactory", "hUser", function(hFormReference, httpHelper, registrationApi, $state, $q, settingsFactory, hUser) {
    return {

        link: function(scope, element) {
            var defer = $q.defer();

            scope.optStatuses = {
                OPT_IN: 'opt-in',
                OPT_OUT: 'opt-out',
            }

            scope.notificationCompleted = function () {
                if ($state.is('appLayout.harriSH.editprofile')) {
                    $state.go('appLayout.harriSH.editprofile', {view: 'work_history'});
                } else {
                    $state.go('appLayout.harriSH.settings.section', {view: 'basic_information'});
                }
            };

            var all_notifications = [];
            var original_employee_referral_settings = {};

            scope.is_user_candidate = hUser.data.user.user_candidate;


            scope.notificationReset= function() {
                //reset form
                scope.reset();

                //return the saved requst
                scope.data.notification.combined_data = [];
                angular.copy(all_notifications,scope.data.notification.combined_data);
            };

            scope.employeeReferralSettingsReset = function () {
                scope.data.notification.employee_referral_settings = angular.copy(original_employee_referral_settings);
            };

            scope.saveEmployeeReferralSettings = function () {
                scope.data.notification.employee_referral_settings.is_opt_out_all = !scope.data.notification.employee_referral_settings.is_employee_referral_enabled;

                for (var i in scope.data.notification.employee_referral_settings.business_brands) {
                    scope.data.notification.employee_referral_settings.business_brands[i].is_opt_out = !scope.data.notification.employee_referral_settings.business_brands[i].is_brand_enabled;
                }

                SocialReferralAPI.editEmployeeReferralSettings(scope.data.notification.employee_referral_settings)
                    .then(function (res) {
                        HNotifications.show({
                            title: self.$filter('translate')("Success"),
                            desc: self.$filter('translate')("Employee Referral updated successfully"),
                            icon: "fa-check-circle",
                            type: "success"
                        });
                        defer.resolve(res);
                    }).catch(function (err) {
                    HNotifications.show({
                        title: this.$filter('translate')("Error"),
                        desc: this.$filter('translate')("Error while updating"),
                        icon: "fa-times",
                        type: "error"
                    });
                    defer.reject(err);
                });
            }

            scope.updateBrandOptStatus = async (brand) => {
                try {
                    let message;
                    const optStatus = brand.is_opted_out ? scope.optStatuses.OPT_IN : scope.optStatuses.OPT_OUT;
                    const brandName = brand.external_name || brand.name;

                    if (brand.is_opted_out) {
                        await TalentPoolAPI2.updateTalentPoolBrandOptSettings(brand.id, scope.userId, optStatus);
                        message = $filter("translate")("Opt in updated successfully");
                        HNotifications.show({
                            title: $filter("translate")("Success"),
                            desc: message,
                            icon: "fa-check",
                            type: "success",
                            timeout: 4000
                        });
                        brand.is_opted_out = false;
                    } else {
                        hConfirm({
                            title: $filter("translate")("Confirm opt out of Talent pool"),
                            text: $filter("translate")(`If you opt out of a Talent pool you won't be matched with jobs that you may be interested in. Are you sure you want to opt out of ${brandName}’s Talent pool?`),
                            confirmButton: $filter("translate")("Confirm"),
                            cancelButton: $filter("translate")("Cancel"),
                            callback: async (confirmed) => {
                                if (confirmed) {
                                    await TalentPoolAPI2.updateTalentPoolBrandOptSettings(brand.id, scope.userId, optStatus);
                                    HNotifications.show({
                                        title: $filter("translate")("Success"),
                                        desc: message,
                                        icon: "fa-check",
                                        type: "success",
                                        timeout: 4000
                                    });
                                    brand.is_opted_out = true;
                                }
                            }
                        });
                        message = $filter("translate")("Opt out updated successfully");
                    }
                } catch (e) {
                    console.error(e);
                    HNotifications.show({
                        title: $filter('translate')("Error"),
                        desc: $filter('translate')("Error while updating"),
                        icon: "fa-times-circle",
                        type: "danger",
                        timeout: 4000
                    });
                } finally {
                    scope.$digest();
                }
            }

            hFormReference.current(element, {
                beforeActive: function(scope) {

                    var defer = $q.defer();
                    scope.team_user_id = hUser.data.user.team_user_id;
                    scope.userId  = hUser.data.user.id;

                    var promises = {};

                    promises.get_all_notifications = httpHelper.g('notification');
                    promises.get_user_notifications = httpHelper.g('notification/user');
                    if (scope.team_user_id) {
                        promises.get_employee_businesses =  TeamAPI.getEmployeeBusinesses();
                        promises.get_employee_referral_settings = SocialReferralAPI.getEmployeeReferralSettings();
                    }
                    if (!!scope.userId) {
                        promises.getCandidateTalentPoolBrands = TalentPoolAPI2.getCandidateTalentPoolBrands();
                    }
                    $q.all(promises).then(function(res) {
                        var data_in_view = [];
                        if(res && res.get_all_notifications && res.get_user_notifications){

                            var data_get_all_notifications = res.get_all_notifications.data.data;

                            for(var i in data_get_all_notifications){
                                var obj = {
                                    code: data_get_all_notifications[i].code,
                                    description: data_get_all_notifications[i].description,
                                    id : data_get_all_notifications[i].id,
                                    name : data_get_all_notifications[i].name,
                                    type: data_get_all_notifications[i].type,
                                    selected: false
                                };
                                if(obj.type == "Operational"){
                                    obj.selected = true;
                                }
                                if(obj.type == "Schedule"){
                                    obj.daily = true;
                                    obj.weekly = true;
                                }
                                data_in_view.push(obj);
                            }

                            var data_get_user_notifications = res.get_user_notifications.data.data;
                            for(var i in data_get_user_notifications){
                                var notification_id = data_get_user_notifications[i].Notification.id;
                                /* ToDo
                                 *
                                 * Improve performance where two loops used here
                                 */
                                for(var j in data_in_view){
                                    if(data_in_view[j].id == notification_id){
                                        data_in_view[j].selected = true;
                                        if(data_in_view[j].type == "Schedule"){
                                            if(data_get_user_notifications[i].UserNotifications.weekly &&
                                                    data_get_user_notifications[i].UserNotifications.weekly == true){
                                                data_in_view[j].weekly = true;
                                            }else{
                                                data_in_view[j].weekly = false;
                                            }

                                            if(data_get_user_notifications[i].UserNotifications.daily &&
                                                    data_get_user_notifications[i].UserNotifications.daily == true){
                                               data_in_view[j].daily = true;
                                            }else{
                                               data_in_view[j].daily = false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (scope.team_user_id && res.get_employee_businesses && res.get_employee_referral_settings) {

                            var data_get_employee_businesses = res.get_employee_businesses;
                            var data_employee_referral_settings = res.get_employee_referral_settings.opt_out_settings;

                            var employee_referral_settings = {
                                is_employee_referral_enabled: !data_employee_referral_settings.is_opt_out_all,
                                business_brands: data_employee_referral_settings.business_brands
                            }

                            for (var i in employee_referral_settings.business_brands) {
                                employee_referral_settings.business_brands[i].is_brand_enabled = !employee_referral_settings.business_brands[i].is_opt_out;
                                employee_referral_settings.business_brands[i].media = data_get_employee_businesses[i].media;
                            }

                            original_employee_referral_settings = angular.copy(employee_referral_settings);
                            scope.data.notification.employee_referral_settings = employee_referral_settings;
                        }
                        if (res.getCandidateTalentPoolBrands?.brands) {
                            scope.brands = JSON.parse(JSON.stringify(res.getCandidateTalentPoolBrands.brands));
                        }

                        scope.data.notification.combined_data = data_in_view;
                        angular.copy(scope.data.notification.combined_data,all_notifications );
                        defer.resolve(res);

                    }, function(errors) {
                        defer.reject(errors);
                    });


                    return defer.promise;

                },
                beforeSave: function(formData, valid) {

                    if(!valid) return;

                    var objArray = [];

                    var dataToSend = formData.combined_data;
                    for(var i in dataToSend){
                        if(dataToSend[i].type == "Operational") continue;
                        var obj = {
                            selected: dataToSend[i].selected,
                            notification_id: dataToSend[i].id,
                        };

                        if(dataToSend[i].type == "Schedule" ){
                            if(dataToSend[i].selected){
                                if(dataToSend[i].daily){
                                    obj.daily = true;
                                }else{
                                    obj.daily = false;
                                }

                                if(dataToSend[i].weekly){
                                    obj.weekly = true;
                                }else{
                                    obj.weekly = false;
                                }
                            }
                        }
                        objArray.push(obj);
                    }
                    return objArray;
                }
            }).then(function(formObj) {

            })

        }
    }
}]);


/* =====================================================*/
/* Social Referral Management - hyper hire
/* =====================================================*/

app.directive('employeeReferralManagementDirective', ['hFormReference', function (hFormReference) {
    return {

        link: function (scope, element) {
            hFormReference.current(element, {
                beforeActive: function (scope) {
                    scope.onActive = true;
                    scope.brandId = hUser.getActiveBrandIdWithAccess();
                }
            });
        }
    }
}]);

/* =====================================================*/
/* Social Referral Messages Template - hyper hire
/* =====================================================*/
app.directive('employeeReferralMessagesTemplatesDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    '$alert',
    'userServices',
    function (hUser, settingsFactory, hFormReference, $alert, userServices) {
        return {
            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.messageTemplateActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        var hasMessageTemplateServicePromise = userServices.isServiceEnabled(userServices.SERVICES.SOCIAL_REFERRAL, scope.brandId);

                        hasMessageTemplateServicePromise.then(function (hasMessageTemplateService) {
                            if (hasMessageTemplateService) {

                                scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                                scope.messageTemplateActive = true;
                            }
                        });


                    }
                });
            }
        }
    }
]);

/* =====================================================*/
/* Invite to Apply Templates - talent pool
/* =====================================================*/
app.directive('inviteToApplyTemplatesDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    '$alert',
    'brandServices',
    'userPermissions',
    '$state',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, $alert, brandServices, userPermissions, $state, hUser) {
        return {
            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.messageTemplateActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        userPermissions.getBrandPolicy(scope.activeBrand.id).then((policyParser) => {
                            const hasManageTalentPoolModulePermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE);
                            if (scope.activeBrand.invite_to_apply?.pool_id && hasManageTalentPoolModulePermission) {
                                scope.messageTemplateActive = true;
                            } else {
                                $state.go("404");
                            }
                        })
                    }
                });
            }
        }
    }
]);

/* =====================================================*/
/* Document Uploader
/* =====================================================*/
app.directive('documentUploaderDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'userPermissions',
    'documentUploaderDataService',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, userPermissions, documentUploaderDataService, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.documentUploaderActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                        if (scope.activeBrand) {
                            documentUploaderDataService.canUseDocumentUploader(scope.activeBrand)
                                .then(function (res) {
                                    scope.documentUploaderActive = res;
                                })
                                .catch(function (err) {
                                    console.log(err);
                                });
                        }
                    },
                });
            }
        }
}]);


app.directive('customSourcesDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    'userPermissions',
    function (hUser, settingsFactory, hFormReference, userPermissions) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.loading = true;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.loading = false;
                    },
                });
            }
        }
    }]);

/* =====================================================*/
/* Offer Templates
/* =====================================================*/
app.directive('offerTemplatesDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'offerTemplatesService',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, offerTemplatesService, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.offerTemplatesActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                        if (scope.activeBrand) {
                            offerTemplatesService.canManageOfferTemplates(scope.activeBrand.id)
                                .then(function (offerTemplatesActive) {
                                    scope.offerTemplatesActive = offerTemplatesActive;
                                })
                                .catch(function (err) {
                                    console.log(err);
                                });
                        }
                    },
                });
            }
        }
}]);

app.directive('hrActionsTemplatesDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'offerTemplatesService',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, offerTemplatesService, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.canManageHrActionsTemplates = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                        if (scope.activeBrand) {
                            offerTemplatesService.canManageHrActionsTemplates(scope.activeBrand.id)
                                .then(function (canManageHrActionsTemplates) {
                                    scope.canManageHrActionsTemplates = canManageHrActionsTemplates;
                                })
                                .catch(function (err) {
                                    console.log(err);
                                });
                        }
                    },
                });
            }
        }
}]);

app.directive('socialReferralTemplatesDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    function (hUser, settingsFactory, hFormReference) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                    },
                });
            }
        }
}]);

app.directive('crmDirective', [
    'settingsFactory',
    'hFormReference',
    '$state',
    'talentPoolDataService',
    'hUser',
    'userPermissions',
    'brandServices',
    function (settingsFactory, hFormReference, $state, talentPoolDataService, hUser, userPermissions, brandServices) {
        return {
            link: (scope, element) => {
                hFormReference.current(element, {
                    beforeDeactivate: (scope) => {
                        scope.showCampaignsList = false;
                        scope.showEmailNotificationsList = false;
                        scope.showTextNotificationList = false;

                        scope.$evalAsync();
                    },
                    beforeActive: (scope) => {
                        scope.loading = true;
                        scope.LOCATION = 'LOCATION';
                        scope.BRAND_SETTINGS = 'BRAND_SETTINGS';
                        scope.CAMPAIGN_TABS = {
                            'CAMPAIGNS': {
                                key: 'CAMPAIGNS',
                                label: $filter("translate")("Campaigns")
                            },
                            'EMAIL_LIST': {
                                key: 'EMAIL_LIST',
                                label: $filter("translate")("Email List")
                            },
                            'TEXT_MESSAGES_LIST': {
                                key: 'TEXT_MESSAGES_LIST',
                                label: $filter("translate")("Text Messages List")
                            },
                        };

                        const TALENT_POOL_CRM = 'TALENT_POOL_CRM';
                        const BALANCE_THRESHOLD = {
                            BALANCE_HIGH_THRESHOLD: 800,
                            BALANCE_MEDIUM_THRESHOLD: 300
                        };

                        const BALANCE_BADGE_COLORS = {
                            HIGH: "secondary",
                            MEDIUM: "warning",
                            LOW: "danger"
                        };

                        const getSMSTextMessagesBalanceBadgeColor = (balance) => {
                            if (balance > BALANCE_THRESHOLD.BALANCE_HIGH_THRESHOLD) {
                                return BALANCE_BADGE_COLORS.HIGH;
                            } else if (balance > BALANCE_THRESHOLD.BALANCE_MEDIUM_THRESHOLD && balance <= BALANCE_THRESHOLD.BALANCE_HIGH_THRESHOLD) {
                                return BALANCE_BADGE_COLORS.MEDIUM;
                            } else {
                                return BALANCE_BADGE_COLORS.LOW;
                            }
                        }

                        scope.setActiveTab = (tab) => {
                            scope.activeCRMTab = tab;
                            $state.go('appLayout.harriSH.settings.brandSection', {
                                view: 'crm',
                                tab: scope.activeCRMTab
                            });
                        };

                        scope.tabs = {};
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                        Promise.all([
                            userPermissions.getBrandPolicy(scope.brandId),
                            brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, scope.brandId),
                        ])
                        .then(([policyParser, isGlobalTalentPoolEnabled]) => {
                            if (
                                isGlobalTalentPoolEnabled &&
                                policyParser.has(userPermissions.PERMISSIONS['MANAGE_TALENT_POOL_CRM'])
                            ) {
                                scope.showCampaignsList = true;
                                scope.tabs[scope.CAMPAIGN_TABS.CAMPAIGNS.key] = scope.CAMPAIGN_TABS.CAMPAIGNS;
                            }

                            if (isGlobalTalentPoolEnabled) {
                                talentPoolDataService.getBrandTalentPoolSettings(scope.brandId).then(async (settings) => {
                                    scope.brandTalentPoolSettings = settings;

                                    scope.showEmailNotificationsList = scope.brandTalentPoolSettings.crm_email_notifications;
                                    scope.showTextNotificationList = scope.brandTalentPoolSettings.crm_text_notifications;

                                    if (scope.showEmailNotificationsList) {
                                        scope.tabs[scope.CAMPAIGN_TABS.EMAIL_LIST.key] = scope.CAMPAIGN_TABS.EMAIL_LIST;
                                    }

                                    if (scope.showTextNotificationList) {
                                        scope.tabs[scope.CAMPAIGN_TABS.TEXT_MESSAGES_LIST.key] = scope.CAMPAIGN_TABS.TEXT_MESSAGES_LIST;

                                        const params = {
                                            type: TALENT_POOL_CRM
                                        }

                                        const result = await NotificationCenterAPIV2.getSMSBalance(scope.brandId, params);
                                        scope.smsRemainingBalance = result?.sms_balances?.length ? result?.sms_balances[0]?.usage?.remaining_balance : null;

                                        if (typeof(scope.smsRemainingBalance) === 'number') {
                                            scope.smsTextBadgeColor = getSMSTextMessagesBalanceBadgeColor(scope.smsRemainingBalance);
                                        }
                                    }
                                }).catch((err) => {
                                    console.error(err)
                                }).finally(() => {
                                    scope.activeCRMTab = scope.CAMPAIGN_TABS.CAMPAIGNS.key;

                                    $state.go('appLayout.harriSH.settings.brandSection', {
                                        view: 'crm',
                                        tab: scope.activeCRMTab
                                    })
                                    scope.loading = false;
                                })
                            }
                        }).catch((err) => {
                            console.error(err)
                        })
                    },
                });
            }
        }
    }]);

/**
 * Directive to auto select primary value from a list
 * If no one is defined - the first item will be selected as primary
 */
app.directive('primarySelector', function(){
  return {
    require:'ngModel',
    scope: {
      'ngModel': '='
    },
    link: function(scope, element, attrs) {
      scope.$watch(function(){
          return scope.ngModel;
        },
        function(newValue, oldValue){
          if (!newValue || newValue.length == 0) {
            return;
          }

          var hasPrimary = false;

          for (var i in newValue) {
            if (newValue[i].is_primary == true) {
              hasPrimary = true;
            }
            else {
              scope.ngModel[i].is_primary = false;
            }
          }

          if (!hasPrimary && scope.ngModel[0]) {
            scope.ngModel[0].is_primary = true;
          }
        }, true);
    }
  }
});

/* =============================================================*/
/* Talent Scout Settings Directive
/* =============================================================*/
app.directive('talentScoutDirective', [
    'hFormReference',
    'hUser',
    '$modal',
    function (hFormReference, hUser, $modal) {
        return {
            link: (scope, element) => {
                const limitExceededErrorCode = 'DAILY_RATE_LIMIT_EXCEEDED';

                hFormReference.current(element, {
                    beforeActive: (scope) => {
                        scope.activeBrandId = hUser.getEntryMode().brand_id;
                        scope.userFullName = `${hUser.data.user.first_name} ${hUser.data.user.last_name}`;
                        TalentPoolAPI2.getUserTalentScoutCode(scope.activeBrandId, hUser.data.user.id).then((res) => {
                            scope.codeImageURL = res.talent_scout_image_url;
                            scope.codeURL = res.url;
                            scope.$digest();
                        })
                    }
                });

                scope.openShareModal = () => {
                    $modal({
                        controller: 'TalentScoutShareModal',
                        controllerAs: '$ctrl',
                        templateUrl: '../modules/settings/modals/talent-scout-share/talent-scout-share.modal.html',
                        backdrop: 'static',
                        resolve: {
                            modalData: function () {
                                return {
                                    url: scope.codeImageURL,
                                    userFullName: scope.userFullName
                                };
                            },
                        }
                    });
                }

                scope.generateQRCode = () => {
                    scope.activeBrandId = hUser.getEntryMode().brand_id;

                    TalentPoolAPI2.regenerateUserTalentScoutCode(scope.activeBrandId, hUser.data.user.id)
                        .then(res => {
                            if (res.error === limitExceededErrorCode) {
                                HNotifications.show({
                                    title: $filter("translate")("Failed"),
                                    desc: $filter("translate")("You can regenerate one QR code each 24 hours"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 4000
                                });
                            } else {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("QR code generated successfully"),
                                    icon: "fa-check",
                                    type: "success",
                                    timeout: 4000
                                });
                                scope.codeImageURL = res.talent_scout_image_url;
                                scope.codeURL = res.url;
                                scope.$digest();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            }
        }
    }
]);

/**
 * Directive for time & location settings
 */
app.directive('timeGeographyDirective', ["httpHelper", "hFormReference", "registrationApi", "$state", "hUser", "settingsFactory", "hEvent", "$timeout", function(httpHelper, hFormReference, registrationApi, $state, hUser, settingsFactory, hEvent, $timeout) {
  return {
    link: function(scope, element) {

        // Initial data, used to reset the form (discard changes)
        var initialGeoData;
        // reference to current form data
        var geoData;
        // Locations to be deleted when user clicks save
        var locationsToDelete = [];

        // Move to next settings form after complete
        scope.geographyCompleted = function () {

            var originalData = JSON.parse(initialGeoData);

            if (originalData.locale.code === geoData.locale.code) {
                if ($state.is('appLayout.harriSH.editprofile')) {
                    $state.go('appLayout.harriSH.editprofile', {view: 'email_notifications'});
                } else {
                    $state.go('appLayout.harriSH.settings.section', {view: 'email_notifications'});
                }
            }
            else {

                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'lang',
                    value: geoData.locale.code,
                    codec: false,
                    expiryDays: 30
                });

                hEvent.track(
                    "language_change",
                    {
                        "to": geoData.locale.code,
                        "from": scope.currentLang,
                        'location': scope.location || "header",
                        "page": $state.current.name
                    },
                    function () {
                        var user = HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.COOKIES,
                            key: 'user'
                        });
                        if (user && user.language) {
                            user.language = geoData.locale.code;
                            HStorageManager.put({
                                storageLevel: HStorageManager.StorageLevels.COOKIES,
                                key: 'user',
                                value: user
                            });
                        }

                        $timeout(function () {
                            hRedirect(hGetUrl($state.href('appLayout.harriSH.editprofile', {view: 'email_notifications'}, {absolute: true}), geoData.locale.code));
                        });
                    });
            }
        };

        // Delete location non-effective until save is clicked
        scope.deleteLocation = function (index) {
            if (geoData.user_location[index].id) {
                locationsToDelete.push(geoData.user_location[index].id);
            }

            geoData.user_location.splice(index, 1);
        };

        // Set location as primary, make all others secondary
        scope.setPrimaryLocation = function (index) {
            for (var i in geoData.user_location) {
                geoData.user_location[i].is_primary = false;
            }

            geoData.user_location[index].is_primary = true;
        };

        // Reset the form with initial loaded values
        scope.geographyReset = function () {
            //reset form
            scope.reset();

            //load custom data
            scope.loadData(JSON.parse(initialGeoData));
        };

        hFormReference.current(element, {
            beforeActive: function (scope) {
                if (!scope.timezones || scope.timezones.length == 0) {
                    scope.timezonesMap = [];

                    // Get list of all available timezones
                    registrationApi.getTimezonesLookup().then(function (timezones) {
                        for (var i in timezones) {
                            scope.timezonesMap[timezones[i].id] = timezones[i];
                        }

                        // Keep watching time_zone and map it to corresponding timezone object when available
                        scope.$watch(function () {
                            return scope.data.geography.time_zone;
                        }, function (value) {
                            if (value && scope.timezonesMap[value]) {
                                scope.data.geography.time_zone = scope.timezonesMap[value];
                            }
                        }, true);

                        scope.timezones = timezones;
                    });
                }

                if (!scope.languages || scope.languages.length == 0) {

                    SettingsAPI
                        .getPublicLocales()
                        .then(function (languages) {

                            scope.languages = languages;
                        });
                }

                var promise = scope.remoteLoad();
                promise.then(function (res) {
                    // Update location coming from API to have label used to avoid duplicate in locations hSelect
                    for (var i in res.data.data.user_location) {
                        res.data.data.user_location[i].label = res.data.data.user_location[i].formatted_address;
                    }
                    initialGeoData = JSON.stringify(res.data.data);
                });

                return promise;
            },
            beforeSave: function (formData, valid) {

                // Delete temporarily added formData
                delete formData.location;
                delete formData.skills;

                // Convert time_zone from Obj to String
                if (formData.time_zone) {
                    formData.time_zone = formData.time_zone.id;
                } else {
                    delete formData.time_zone;
                }

                if (formData.user_location && formData.user_location.length > 0) {
                    // Convert locations to structure that backend understands
                    for (var i in formData.user_location) {
                        if (formData.user_location[i] && formData.user_location[i].value) {
                            formData.user_location[i] = {
                                'google_location': {
                                    'result': formData.user_location[i].value.result,
                                    'status': 'OK'
                                },
                                'is_primary': formData.user_location[i].is_primary
                            };
                        }
                        else {
                            formData.user_location[i] = {
                                'location_id': formData.user_location[i].id,
                                'is_primary': formData.user_location[i].is_primary
                            };
                        }
                    }
                }

                // Perform delete for marked for delete items
                settingsFactory.deleteLocations(locationsToDelete);

                return formData;
            }
        }).then(function (formObj) {
            geoData = formObj.scope.data.geography;
        });
    }
  }
}]);

/* =============================================================*/
/* Apply To Talent Pool Settings Directive
/* =============================================================*/
app.directive('applyToTalentPoolDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    function (hUser, settingsFactory, hFormReference) {
        return {
            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: (scope) => {
                        scope.applyToTalentPoolSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: (scope) => {
                        scope.applyToTalentPoolSettingsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => {
                            return brand.id === scope.brandId;
                        });
                    }
                });
            }
        }
    }
]);

/* =============================================================*/
/* Automated onboarding Settings Directive
/* =============================================================*/
app.directive('automatedOnboardingSettingsDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    (hUser, settingsFactory, hFormReference) => {
        return {
            link: (scope, element) => {

                hFormReference.current(element, {
                    beforeDeactivate: (scope) => {
                        scope.onboardingAutomationSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: (scope) => {
                        scope.onboardingAutomationSettingsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                    }
                });
            }
        }
    }
]);


/* =============================================================*/
/* Brand General Settings Directive
/* =============================================================*/
app.directive('brandGeneralSettingsDirective', ["hFormReference", "registrationApi", "$state", "$q", "settingsFactory", "$stateParams", "$rootScope", "$modal", "brandServices", "userPermissions", "hUser", function(hFormReference, registrationApi, $state, $q, settingsFactory, $stateParams,$rootScope,$modal, brandServices, userPermissions, hUser) {
    return {

        link: function(scope, element) {

            var reloadedData;

            scope.urlRegex = /^http[s]?:\/\/(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,63}\.?|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/i;
            scope.data.brand_general_settings.brand_id = hUser.getActiveBrandIdWithAccess();

            scope.brandGeneralSettingsCompleted = function () {
                scope.$emit("brandSettingsNavigation.next");
            };
            //var account_alerts = true;
            scope.brandGeneralSettingsReset= function() {
                //reset form
                scope.reset();
                //return the saved requst
                scope.loadData(reloadedData);
                scope.data.brand_general_settings.brand_id = hUser.getActiveBrandIdWithAccess();
            };

            hFormReference.current(element, {
                beforeActive: function(scope) {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                    scope.activeBrand = hUser.data.user.brands_list.find((brand) => {
                        return brand.id === activeBrandId;
                    });
                    scope.isHighestParent = scope.activeBrand.id === scope.activeBrand.group_id;
                    var promises = {};

                    promises['policyParser'] = userPermissions.getBrandPolicy(scope.activeBrand.id);

                    promises['brandBasicInfo'] = settingsFactory.brandBasicInformation(activeBrandId);
                    promises['isCarriChatBotEnabled'] = brandServices.check(brandServices.SERVICES.CARRI_CHATBOT, activeBrandId);
                    promises['isMFAServiceEnabled'] = brandServices.check(brandServices.SERVICES.MFA, activeBrandId);

                    scope.isEnterprise = scope.activeBrand.type == 'enterprise';

                    return $q.all(promises)
                        .then(function (res) {
                            var policyParser = res['policyParser'];
                            scope.hasManageBrandDetailsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BRAND_DETAILS);
                            scope.carriChatBotEnabled = res['isCarriChatBotEnabled'];
                            scope.isMFAServiceEnabled = res['isMFAServiceEnabled'];
                            if (res && res['brandBasicInfo'] && res['brandBasicInfo'].data) {
                                var resultData = res['brandBasicInfo'].data.data;
                                scope.brandType = resultData.type;
                                reloadedData = resultData;
                                reloadedData.brand_id = activeBrandId;
                                var atrs = ['brand_id', 'external_business_name', 'apply_external_business_name_to_children', 'name', 'slug', 'description', 'url', 'facebook_url', 'linkedin_url', 'instagram_url', 'twitter_url', 'youtube_url', 'tiktok_url'];
                                reloadedData = keepAttrs(reloadedData, atrs);
                                resultData.url =  resultData.url || '';
                                resultData.facebook_url =  resultData.facebook_url || '';
                                resultData.linkedin_url =  resultData.linkedin_url || '';
                                resultData.instagram_url =  resultData.instagram_url || '';
                                resultData.twitter_url =  resultData.twitter_url || '';
                                resultData.youtube_url =  resultData.youtube_url || '';
                                resultData.tiktok_url =  resultData.tiktok_url || '';
                                // undefined is sent to because we have an optional parameter (index)
                                scope.loadData(resultData, undefined, true);
                            }
                        });
                },
                beforeSave: function(formData, valid) {
                  //  scope.resetRemoteValidation();
                },
                afterSave: function(data, formData, requestStatus) {
                    scope.$emit('brandChanged')
                }
            }).then(function(formObj) {

            })

        }
    }
}]);

app.directive('brandPosPositionsMappingDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'userServices',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, userServices, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.active = false;
                        scope.isToastSyncServiceEnabled = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        userServices.isServiceEnabled(userServices.SERVICES.POS_TOAST_SYNC, scope.brandId)
                            .then(function (isToastSyncServiceEnabled) {
                                scope.isToastSyncServiceEnabled = isToastSyncServiceEnabled;
                                if (isToastSyncServiceEnabled) {
                                    scope.activeBrand = hUser.data.user.brands_list.find((brand) => {
                                        return brand.id === scope.brandId;
                                    });
                                    scope.active = true;
                                }
                            });
                    }
                });
            }
        }
    }
]);

app.directive('brandBackgroundChecksDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.brandBackgroundChecksActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandBackgroundChecksActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                    }
                });
            }
        }
    }
]);

app.directive('brandAutomatedMetricsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.brandAutomatedMetricsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandAutomatedMetricsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                    }
                });
            }
        }
    }
]);

app.directive('brandEmailsBrandingSettingsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'userServices',
    'brandedCommsService',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, userServices, brandedCommsService,hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.emailsBrandingActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.emailsBrandingActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();

                        brandedCommsService.getManageEmailsContent(scope.brandId)
                            .then(function (brandedCommSettings) {
                                scope.templateType = brandedCommSettings.templates;
                            });
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                    }
                });
            }
        }
    }
]);


app.directive('blockedTerminatedEmployeesDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.blockedTerminatedEmployeesActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.blockedTerminatedEmployeesActive = true;
                    }
                });
            }
        }
    }
]);

app.directive('brandPositionsSettingsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.brandPositionsSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.brandPositionsSettingsActive = true;
                    }
                });
            }
        }
    }
]);

app.directive('communicationHubSettingsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.communicationHubSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.communicationHubSettingsActive = true;
                    }
                });
            }
        }
    }
]);

app.directive('reportsSettingsDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    'userServices',
    function (hUser, settingsFactory, hFormReference, userServices) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.isSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.isSettingsActive = true;
                    }
                });
            }
        }
    }
]);


/* =============================================================*/
/* Manage Permissions Settings Directive
/* =============================================================*/
app.directive('managePermissionsSettingsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.managePermissionsSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.managePermissionsSettingsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                    }
                });
            }
        }
    }
]);

/* =============================================================*/
/* Career Story Settings Directive
/* =============================================================*/
app.directive('careerStorySettingsDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    function (hUser, settingsFactory, hFormReference) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: (scope) => {
                        scope.careerStorySettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: (scope) => {
                        scope.careerStorySettingsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);}
                });
            }
        }
    }
]);


/* =============================================================*/
/* User Management Settings Directive
/* =============================================================*/
app.directive('userManagementSettingsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, hUser) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.userManagementSettingsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.userManagementSettingsActive = true;
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                    }
                });
            }
        }
    }
]);

/* =============================================================*/
/* Approval Flow Settings Directive
/* =============================================================*/
app.directive('approvalFlowSettingsDirective', [
    'hUser',
    'settingsFactory',
    'hFormReference',
    'userServices',
    'userPermissions',
    'jobApprovalDataService',
    function (hUser, settingsFactory, hFormReference, userServices, userPermissions, jobApprovalDataService) {
        return {

            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.approvalFlowSettingsActive = false;
                        scope.showAtrTab = false;
                        scope.showJobApprovalTab = false;
                        scope.showHrActionsApprovalTab = false;
                        scope.showWageJobTitleTab = false;
                        scope.showEmployeeTransfareShare = false;
                        scope.selectedTabItem = '';

                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.approvalFlowSettingsActive = true;
                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                        scope.brandId = activeBrandId;
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        const isHighestParent = scope.activeBrand.id === scope.activeBrand.group_id;
                        scope.approvalFlowTabs = jobApprovalDataService.SERVICES_NEED_APPROVALS;

                        var promises = {};
                        promises['atr_service'] = userServices.isServiceEnabled(userServices.SERVICES.ATR, activeBrandId, true);
                        promises['job_approval_service'] = userServices.isServiceEnabled(userServices.SERVICES.JOB_APPROVAL_FLOW, activeBrandId);
                        promises['approval_service'] = userServices.isServiceEnabled(userServices.SERVICES.APPROVAL_FLOW, activeBrandId);
                        promises['hr_actions_service'] = userServices.isServiceEnabled(userServices.SERVICES.HR_ACTIONS, activeBrandId);
                        promises['policyParser'] = userPermissions.getBrandPolicy(activeBrandId);
                        promises['getBrandApprovalFlowSettings'] = jobApprovalDataService.getBrandApprovalFlowSettings(activeBrandId)

                        if (isHighestParent) {
                            promises['hasPMSService'] = brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, activeBrandId, true);
                            promises['SecondApprovalSettings'] = PmsAPI.getBusinessBrandSettings(activeBrandId);
                        }

                        $q.all(promises)
                            .then(function (data) {
                                var hasATRService = data['atr_service'];
                                var hasJobApprovalService = data['job_approval_service'];
                                let hasApprovalService = data['approval_service'];
                                var hasHrActionsService = data['hr_actions_service'];
                                var policyParser = data['policyParser'];
                                var brandApprovalFlowsSettings = data['getBrandApprovalFlowSettings'] && data['getBrandApprovalFlowSettings'].settings;
                                const showForecastApprovalFlowTab = brandApprovalFlowsSettings['labor_forecast_enabled'];
                                var showWageJobTitleTab = brandApprovalFlowsSettings['teamlive_position_enabled'];
                                var showEmployeeTransfareShare = brandApprovalFlowsSettings['teamlive_location_period_enabled'];
                                let isOfferApprovalFlowSettingsEnabled = brandApprovalFlowsSettings?.offer_letter_enabled;
                                let isDocumentsApprovalFlowSettingsEnabled = brandApprovalFlowsSettings?.documents_enabled;
                                self.hasPMSService =  !!data['hasPMSService'];
                                scope.secondApprovalSettings = data['SecondApprovalSettings'];
                                self.isSecondApprovalReviewsEnabled = data['SecondApprovalSettings']?.enable_reviews_second_approval;
                                self.hasSecondApprovalsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);


                                if (hasATRService && policyParser.has(userPermissions.PERMISSIONS.MANAGE_ATR)) {
                                    ATRAPI.getBrandSettings(scope.brandId)
                                        .then(function (atrSettings) {
                                            if (['MB'].indexOf(atrSettings.atr_type) > -1) {
                                                scope.showAtrTab = true;
                                                scope.selectedTabItem = 'atr_tab';
                                            }
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                        });
                                }

                                if (hasJobApprovalService && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS)) {
                                    scope.showJobApprovalTab = true;
                                    scope.selectedTabItem = 'JOB_APPROVAL_FLOW';
                                    jobApprovalDataService.setActiveService('JOB_APPROVAL_FLOW');
                                }
                                if (hasApprovalService && isOfferApprovalFlowSettingsEnabled) {
                                    scope.isShowOfferApprovalFlow = true;
                                    scope.selectedTabItem = 'OFFER_LETTER';
                                    jobApprovalDataService.setActiveService('OFFER_LETTER');
                                }
                                if (hasApprovalService && isDocumentsApprovalFlowSettingsEnabled) {
                                    scope.isShowDocumentsApprovalFlow = true;
                                    scope.selectedTabItem = 'DOCUMENTS';
                                    jobApprovalDataService.setActiveService('DOCUMENTS');
                                }

                                if (hasHrActionsService && policyParser.has(userPermissions.PERMISSIONS.VIEW_HR_ACTIONS) && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS)) {
                                    scope.showHrActionsApprovalTab = true;
                                    scope.selectedTabItem = 'HR_ACTIONS';
                                    jobApprovalDataService.setActiveService('HR_ACTIONS');
                                }

                                if (showWageJobTitleTab && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS)) {
                                    scope.showWageJobTitleTab = true;
                                    scope.selectedTabItem = 'TEAMLIVE_POSITION';
                                    jobApprovalDataService.setActiveService('TEAMLIVE_POSITION');
                                }

                                if (showEmployeeTransfareShare && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS)) {
                                    scope.showEmployeeTransfareShare = true;
                                    scope.selectedTabItem = 'TEAMLIVE_LOCATION_PERIOD';
                                    jobApprovalDataService.setActiveService('TEAMLIVE_LOCATION_PERIOD');
                                }

                                if (showForecastApprovalFlowTab && isHighestParent && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS)) {
                                    scope.showForecastApprovalFlowTab = true;
                                    scope.selectedTabItem = 'LABOR_FORECAST';
                                    jobApprovalDataService.setActiveService('LABOR_FORECAST');
                                }

                                if (scope.isPerformanceSecondApprovalShown()) {
                                    scope.selectedTabItem = scope.approvalFlowTabs.PERFORMANCE_SECOND_APPROVAL.code;
                                }

                            });

                        scope.setActiveTab = function(activeTab) {
                            scope.selectedTabItem = activeTab;
                            if ([ scope.approvalFlowTabs.HR_ACTIONS.code, scope.approvalFlowTabs.JOB_APPROVAL_FLOW.code,
                                scope.approvalFlowTabs.TEAMLIVE_POSITION.code, scope.approvalFlowTabs.TEAMLIVE_LOCATION_PERIOD.code,
                                scope.approvalFlowTabs.LABOR_FORECAST.code, scope.approvalFlowTabs.OFFER_LETTER.code,
                                scope.approvalFlowTabs.DOCUMENTS.code].indexOf(activeTab) > -1) {
                                jobApprovalDataService.setActiveService(activeTab);
                            }
                        };

                        scope.isPerformanceSecondApprovalShown = () => {
                            return (
                                self.hasPMSService &&
                                self.isSecondApprovalReviewsEnabled &&
                                self.hasSecondApprovalsPermission
                            );
                        };

                    }
                });
            }
        }
    }
]);

/* =============================================================*/
/* Brand Billing Directive
/* =============================================================*/
app.directive('brandBillingDirective', ["hFormReference", "$state", "$q", "httpHelper", "hUser", function(hFormReference, $state, $q, httpHelper, hUser) {
    return {
        link: function(scope, element) {

            var reloadedData;

            scope.predicate = 'type';

            scope.formatDate = function(date) {
                var dateOut = new Date(date);
                return dateOut;
            };

            scope.hideErrorMessage = function (){
              scope.data.brand_billing.payment_method_message_error = "";
            };

            scope.hideSucessMessage = function (){
              scope.data.brand_billing.payment_method_message_sucess= "";
            };

            scope.hideCancelSubscriptionErrorMessage = function () {
                scope.data.brand_billing.cancel_subscription_error_message = "";
            };

            scope.hideCancelSubscriptionSuccessMessage = function () {
                scope.data.brand_billing.cancel_subscription_success_message = "";
            };

            scope.deletePaymentMethod = function (paymentMethod, index) {
                StripeAPI.deletePaymentMethod(scope.data.brand_billing.brand_id, paymentMethod.id)
                    .then(function (data) {
                        if (data.status_code == 200) {
                            for (var i in scope.data.brand_billing.payment_methods) {
                                if (scope.data.brand_billing.payment_methods[i].id === paymentMethod.id) {
                                    scope.data.brand_billing.payment_methods.splice(i, 1);
                                }
                            }
                            scope.data.brand_billing.payment_method_message_sucess = $filter("translate")("Payment method deleted successfully.");
                        } else {
                            scope.data.brand_billing.payment_method_message_error = $filter("translate")("Failed to delete payment method.");
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                        scope.data.brand_billing.payment_method_message_error = $filter("translate")("Failed to delete payment method.");
                    })
                    .finally(function () {
                        scope.$digest();
                    });
            };


          /**
           * Cancel Current Subscription
           * @param subscriptionId
           */
          scope.cancelSubscription = function (index) {
              hConfirm({
                  title: $filter("translate")("Cancel Subscription"),
                  text: $filter("translate")("Are you sure you want to cancel your subscription?"),
                  callback: function (confirmed) {
                      if (confirmed) {
                          setTimeout(function () {
                              scope.$digest();
                          }, 1);

                          StripeAPI.cancelSubscription(scope.data.brand_billing.brand_id, scope.data.brand_billing.subscriptions[index].id)
                              .then(function (res) {
                                  if (res.status_code == 200) {
                                      scope.data.brand_billing.cancel_subscription_success_message = $filter("translate")("Plan was canceled successfully. Your credits will remain till") + ' ' + moment(scope.data.brand_billing.subscriptions[index].current_period_end*1000).locale('en').format('MMMM DD, YYYY') + '.';
                                      scope.data.brand_billing.subscriptions.splice(index);
                                  } else {
                                      scope.data.brand_billing.cancel_subscription_error_message = $filter("translate")("Failed to cancel your subscription.");
                                  }
                                  scope.$digest();
                              })
                              .catch(function (err) {
                                  console.error(err);
                                  scope.data.brand_billing.cancel_subscription_error_message = $filter("translate")("Failed to cancel your subscription.");
                              })
                      }
                  }
              });
          };

            scope.setPrimaryPaymentMethod = function (paymentMethod) {

                StripeAPI.setPrimaryPaymentMethod(scope.data.brand_billing.brand_id, paymentMethod.id)
                    .then(function (data) {
                        if (data.status_code == 200) {
                            scope.data.brand_billing.default_source = paymentMethod.id;
                            scope.data.brand_billing.payment_method_message_sucess = $filter("translate")("Card has been set as primary payment method successfully");
                        } else {
                            scope.data.brand_billing.payment_method_message_error = $filter("translate")("Failed to set card as primary payment method.");
                        }

                        scope.$digest();
                    })
                    .catch(function (err) {
                        console.error(err);
                        scope.data.brand_billing.payment_method_message_error = $filter("translate")("Failed to set card as primary payment method.");
                    });
            };

            hFormReference.current(element, {
                beforeActive: function(scope) {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                    scope.data.brand_billing.brand_id = activeBrandId;
                    var defer = $q.defer();

                    StripeAPI.getBrandTransactions(activeBrandId)
                        .then(function (transactions) {
                            var response = transactions;

                            var customPackageString = "custom package";
                            var translatedCustomPackageString = $filter("translate")("custom package");

                            scope.data.brand_billing.brands = response.brands;

                            for (var b in scope.data.brand_billing.brands) {

                                var brand = scope.data.brand_billing.brands[b];
                                var charges = brand.charges;

                                for (var c in charges) {

                                    var transaction = charges[c];
                                    var subscriptionPackage = transaction.subscription_package;

                                    if (subscriptionPackage && subscriptionPackage.name.indexOf(customPackageString) > -1) {
                                        subscriptionPackage.name = subscriptionPackage.name.replace(customPackageString, translatedCustomPackageString);
                                    }
                                }
                            }

                            scope.data.brand_billing.subscriptions = response.subscriptions && response.subscriptions.data;

                            for (var s in scope.data.brand_billing.subscriptions) {

                                var subscription = scope.data.brand_billing.subscriptions[s];
                                var subscriptionPlan = subscription.plan;

                                if (subscriptionPlan && subscriptionPlan.name.indexOf(customPackageString) > -1) {
                                    subscriptionPlan.name = subscriptionPlan.name.replace(customPackageString, translatedCustomPackageString);
                                }
                            }

                            scope.data.brand_billing.payment_methods = response.sources && response.sources.data;
                            scope.data.brand_billing.default_source = response.default_source;

                            defer.resolve(transactions);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });

                    return defer.promise;
                }
            }).then(function(formObj) {

            })

        }
    }
}]);


app.directive('atrsSettingsDirective', ["hFormReference", "httpHelper", "hUser", "registrationApi", "$state", "$q", "settingsFactory", "userServices", function (hFormReference, httpHelper, hUser, registrationApi, $state, $q, settingsFactory, userServices) {
    return {
        link: function ($scope, element) {
            hFormReference.current(element, {
                beforeDeactivate: function (scope) {
                    scope.ATRActive = false;
                    scope.$evalAsync();
                },
                beforeActive: function (scope) {
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                    userServices.isServiceEnabled(userServices.SERVICES.ATR, activeBrandId)
                        .then(function (hasATRService) {
                            if(hasATRService) {
                                scope.ATRActive = true;
                                scope.brandId = activeBrandId;

                                ATRAPI.getBrandSettings(scope.brandId)
                                    .then(function (atrSettings) {
                                        scope.ATRType = atrSettings.atr_type;
                                    })
                                    .catch(function (err) {
                                        console.error(err);
                                    });
                            }
                        });

                }
            });
        }
    }
}]);


app.directive('hFormRemoteLoad', ["httpHelper", "$q", "hFormReference", function(httpHelper, $q, hFormReference) {
    return {
        link: function(scope, element) {

            hFormReference.current(element, {
                beforeActive: function() {
                    return scope.remoteLoad();
                }
            });

        }
    }
}]);

/* =============================================================*/
/* Brand New Payment Method
/* =============================================================*/
app.directive('newBrandPaymentMethodDirective', ["hFormReference", "$state", "hUser", "$filter", "brandServices", function (hFormReference, $state, hUser, $filter, brandServices) {
    return {

        link: function(scope, element) {


            scope.newBrandPaymentMethodCompleted = function() {
                $state.go('appLayout.harriSH.settings.brandSection', {view:'billing'});
                hFormReference.current(element).then(function(formObj) {
                  formObj.scope.data.new_brand_payment_method = {};
                });
            };
            scope.newBrandPaymentMethodCancel = function() {
                $state.go('appLayout.harriSH.settings.brandSection', {view:'billing'});
                hFormReference.current(element).then(function(formObj) {
                    formObj.scope.data.new_brand_payment_method = {};
                });
            };

            scope.scrollToError = function(){
              $('#settings-cont').animate({
                  scrollTop: parseInt($('.form-group.has-error:visible').first().offset().top),
                },
                'slow');
            };

            hFormReference.current(element, {
                beforeActive: function(scope) {
                    scope.data.new_brand_payment_method.brand_id = hUser.getActiveBrandIdWithAccess();
                    brandServices.check(brandServices.SERVICES.JOB_DISTRIBUTOR, scope.data.new_brand_payment_method.brand_id).then(function(isValid){
                        scope.data.new_brand_payment_method.has_job_distributor = !isValid;
                    });
                },
                beforeSave: function(formData, valid) {

                    var defer = $q.defer();

                    if(!valid){
                      scope.scrollToError();
                      return;
                    }

                    formData.expiration_date = moment(formData.expiration_date).format('MM/YYYY');

                    var stripeData = {
                        number: formData.card_number,
                        cvc: formData.card_code,
                        exp: formData.expiration_date,
                        name: formData.first_name + " " + formData.last_name,
                        address_line1: formData.address,
                        address_line2: "",
                        address_city: formData.city,
                        address_state: formData.state,
                        address_zip: formData.zip,
                        address_country: formData.country
                    };

                    $("button#save_payment").button("loading");

                    PaymentStripe.init()
                        .then(function () {

                            PaymentStripe.createToken(stripeData, function (status, cardDetails) {

                                if (status === 200 && cardDetails) {
                                    defer.resolve({
                                        "credit_card": cardDetails.id,
                                        "brand_id": formData.brand_id,
                                        'set_as_default': !!formData.set_as_default
                                    });
                                }
                                else {

                                    var errorMsg = $filter("translate")("Please check your payment method information.");

                                    if (cardDetails && cardDetails.error && cardDetails.error.message) {
                                        errorMsg = cardDetails.error.message;
                                    }

                                    hAlert(
                                        $filter("translate")("Something went wrong"),
                                        $filter("translate")(errorMsg)
                                    );

                                    $("button#save_payment").button('reset');

                                    defer.reject(errorMsg);
                                }

                            });

                        });

                    return defer.promise;
                },
                afterSave: function(data, formData, requestStatus) {
                    if(data && data.status_code && data.status_code == 600 && data.data == "") {
                        data.status_code = 304;
                        data.data = data.status = $filter("translate")("An error occurred while processing your credit card, please check your information.");
                    }

                    return data;
                }
            }).then(function(formObj) {

            })

        }
    }
}]);

app.directive('mediaHostedVideos', ["httpHelper", "$q", "hFormReference", "settingsFactory", "$state", "hUser", "hTransitions", function (httpHelper, $q, hFormReference, settingsFactory, $state, hUser, hTransitions) {
    return {
        link: function (scope, element) {
            var $scope = scope;
            scope.isEmployer = hUser.isEmployer();
            scope.brand_id = hUser.getActiveBrandIdWithAccess();

            scope.goNext = function(){
              scope.$emit("brandSettingsNavigation.next");
            };

            hFormReference.current(element, {
                beforeActive: function() {
                    scope.routeFrom = function(viewName, data) {
                        var isEmployer = scope.isEmployer;
                        var isCandidate = !scope.isEmployer;

                        switch(viewName) {
                            case 'registration/brand_media':
                                $("#join-modal .modal").animate({scrollTop:0});

                                $scope.isBrandMedia = true;


                                if(data && data.to == 'link-video') {
                                    $scope.goto('registration/hosted_video');
                                } else {
                                    if(!data.iconUUID) {
                                        $scope.brandMediaIconRequiredErrorFlag=true;
                                        return;
                                    }

                                    //go and add another brand if needed.
                                    if($scope.data.multiBrandView) {

                                        //reset company profile
                                        $scope.reset({}, $scope.indexOf('registration/company_profile'));
                                        try {
                                            $scope.data.locations.list = [];
                                        } catch(e) {}

                                        $scope.goto('registration/company_profile');

                                    } else {
                                        //goto brand profile
                                        if(isCandidate) {
                                            $scope.goto('registration/work_history');
                                        } else {
                                            hRedirect("/" + data.slug);
                                        }
                                    }
                                }

                            break;
                            case 'registration/user_media':
                                $scope.isBrandMedia = false;

                                if(data.to == 'link-video') {
                                    $scope.goto('registration/hosted_video');
                                }
                            break;

                        }

                    }
                }
            });
        }
    }
}]);









app.directive('scheduleSettings', ["httpHelper", "$q", "hFormReference", "settingsFactory", function(httpHelper, $q, hFormReference, settingsFactory) {
    return {
        link: function (scope, element) {

            hFormReference.current(element, {
                beforeSave: function(formData) {
                    if(formData.optional) {
                        delete formData.optional;
                    }

                    removeAttrs(formData, ['email', 'first_name', 'last_name', 'phone', 'positions', 'slug']);

                    return formData;
                }
            });

        }
    }
}]);


/* =============================================================*/
/* Brand Job Templates Settings
 /* =============================================================*/

app.directive('brandJobTemplatesDirective', ["httpHelper", "hFormReference", "$state", "$stateParams", "$timeout", "$filter", "settingsFactory", "hUser", "userPermissions", "positionsDataService", "brandServices", "$location", "$q", function(httpHelper,hFormReference, $state, $stateParams,$timeout,$filter, settingsFactory, hUser, userPermissions, positionsDataService, brandServices, $location, $q) {
  return {

    link: function(scope, element) {

        scope.postJobFromTemplate = function (template) {
            if (template && template.position) {
                positionsDataService.isActivePosition(template.position.code, scope.data.brand_job_templates.brand_id)
                    .then(function (isActivePosition) {
                        if (isActivePosition) {
                            $state.go('appLayout.harriSH.job_create', {
                                job_id: template.id,
                                jobBrandId: scope.data.brand_job_templates.brand_id,
                                brandType: scope.brandType,
                                source: scope.templateSource
                            });
                        } else {
                            hConfirm(
                                {
                                    title: $filter('translate')('Incomplete job details'),
                                    text: $filter('translate')('Please update the job post position, the current selected position is no longer available.'),
                                    confirmButton: $filter("translate")("Okay"),
                                    cancelButtonClass: 'hidden'
                                }
                            );
                        }
                    })
            }
        };

      scope.removeJobTemplate = function(job_id,job_title,modalObj){
          hConfirm($filter("translate")("Are you sure you want to delete")+" '"+job_title+"' "+$filter("translate")("job template?"), function(result) {
            if(result) {
              var promise = httpHelper.d('jobs/'+job_id);
              promise.then(function (){
                  for(var i in scope.data.brand_job_templates.templates){
                    if(scope.data.brand_job_templates.templates[i].id == job_id){
                      scope.data.brand_job_templates.templates.splice(i,1);
                    }
                  }
              });

              return promise;
            }
          });
      };

      hFormReference.current(element, {
          beforeDeactivate: function (scope) {
              if ($stateParams.view !=="job_templates") {
                  $location.search('tab', null);
              } else {
                  if (hUser.getActiveBrandIdWithAccess() !== scope.data.brand_job_templates.brand_id) {
                      scope.setActiveSubTab("JOB")
                  }
              }
              scope.$evalAsync();
          },
        beforeActive: function(scope) {

            scope.loading = true;
            const activeBrandId = hUser.getActiveBrandIdWithAccess();
            scope.data.brand_job_templates.brand_id = activeBrandId;

            scope.setActiveSubTab = function (tab) {
                scope.activeTab = tab
                $location.search('tab', scope.activeTab);
            }

            let activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === parseInt(activeBrandId));

            if (activeBrand) {
                scope.brandType = activeBrand.type;
            }

            var promises = {};

            promises['brandTemplates'] = BrandAPI.getBrandJobTemplates(activeBrandId, false, false, false, {});
            promises['policyParser'] = userPermissions.getBrandPolicy(activeBrandId);
            promises['isAQAAFServiceEnabled'] = brandServices.check(brandServices.SERVICES.AQAAF, activeBrandId);

            return $q.all(promises).then(function (result) {
                var policyParser = result['policyParser'];

                scope.hasJobPostPermission = policyParser.hasAny(userPermissions.CREATE_JOB_PERMISSIONS);
                scope.hasEditPostPermission = policyParser.has(userPermissions.PERMISSIONS.CREATE_EDIT_JOB_POST);
                scope.isAQAAFServiceEnabled = result['isAQAAFServiceEnabled'];

                if (!(scope.hasJobPostPermission || scope.hasEditPostPermission)) {
                    $state.go('404');
                }

                scope.activeTab = ($stateParams.tab === "JOB" || $stateParams.tab === "SCREENING") ? $stateParams.tab : "JOB";

                $location.search('tab', scope.activeTab);

                var brandTemplates = result['brandTemplates'];

                for (var i in brandTemplates.inherited_templates) {
                    var templateContainer = brandTemplates.inherited_templates[i];

                    for (var j in templateContainer.templates) {
                        templateContainer.templates[j].is_parent_template = true;
                    }
                }

                if(brandTemplates && brandTemplates.templates && brandTemplates.inherited_templates ) {
                    brandTemplates.templates = brandTemplates.templates.concat(brandTemplates.inherited_templates);
                }
                scope.data.brand_job_templates.templates = [];

                for (var i in brandTemplates.templates) {
                    var templatesContainer = brandTemplates.templates[i];
                    var position = templatesContainer.position

                    for (var j in templatesContainer.templates) {
                        templatesContainer.templates[j].position = position;
                        scope.data.brand_job_templates.templates.push(templatesContainer.templates[j]);
                    }
                }
                scope.templateSource = $state.current.name ==='appLayout.harriSH.settings.brandSection' ? 'settingsTemplates' : 'hiringDashboardTemplates'
                scope.loading = false;
                scope.$digest();
            }).catch(function(err){
                console.error(err);
            });

        }
      }).then(function(formObj) {

      })

    }
  }
}]);


/* =============================================================*/
/* Brand Notifications Settings
/* Nothing Implemeneted here otherthan moving to next stage
 */
 /* =============================================================*/

app.directive('brandJobTemplatesDirective', ["httpHelper", "hFormReference", "$state", "$stateParams", "$timeout", "$rootScope", function(httpHelper,hFormReference, $state, $stateParams,$timeout,$rootScope) {
  return {

    link: function(scope, element) {

      scope.next = function(){
        scope.$emit("brandSettingsNavigation.next");
      };

      hFormReference.current(element, {
        beforeActive: function(scope) {
            //before active call
        }
      }).then(function(formObj) {

      });

    }
  }
}]);

/* =============================================================*/
/* Brand Communication Emails Settings
 /* =============================================================*/

app.directive('brandCommunicationEmailsSettingsDirective',
    ["userPermissions", "$q", "httpHelper", "hFormReference", "$state", "$stateParams", "$timeout", "$filter", "registrationApi", "hUser", "$modal", "settingsFactory", "brandServices", "adminsUsersService",
        function (userPermissions, $q, httpHelper, hFormReference, $state, $stateParams, $timeout, $filter, registrationApi, hUser, $modal, settingsFactory, brandServices, adminsUsersService) {
            return {
                link: function (scope, element) {
                    var self = this;
                    var categoryCodes = ["FOH", "BOH", "QS", "MANAGE", "Exec-Indus", "OTHER"];

                    var bulkObject = {};
                    var dataStatus = {};
                    const activeBrandId = hUser.getActiveBrandIdWithAccess();

                    hFormReference.current(element, {
                        beforeActive: function (scope) {

                            scope.loading = true;
                            scope.activeMode = "HIRING_PROCESS";

                            if (!dataStatus[activeBrandId]) {
                                dataStatus[activeBrandId] = {
                                    HIRING_PROCESS: {
                                        data: {},
                                        isLoaded: false
                                    },
                                    TERMINATION_TRANSFER: {
                                        data: {},
                                        isLoaded: false
                                    },
                                    DOCUMENTS_EXPIRY: {
                                        data: {},
                                        isLoaded: false
                                    }
                                };
                            }

                            var promisesList = {};
                            promisesList['policyParser'] = userPermissions.getBrandPolicy(activeBrandId);
                            promisesList['VIDEO_INTERVIEW'] = brandServices.check(brandServices.SERVICES.VIDEO_INTERVIEW, activeBrandId);
                            promisesList['BACKGROUND_CHECK'] = brandServices.check(brandServices.SERVICES.BACKGROUND_CHECK, activeBrandId);
                            promisesList['documentSets'] = OnBoardingAPI.getBrandDocumentSets(activeBrandId);
                            promisesList['onBoardingSettings'] = OnBoardingAPI.getOnboardingBrandSettings(activeBrandId);
                            promisesList['isOnBoardingServiceEnabled'] = brandServices.check(brandServices.SERVICES.ON_BOARDING, activeBrandId);
                            promisesList['isReadyToOfferColumnServiceEnabled'] = brandServices.check(brandServices.SERVICES.READY_TO_OFFER_COLUMN, activeBrandId);

                            $q.all(promisesList)
                                .then(function (results) {
                                    scope.onBoardingServiceEnabled = results['isOnBoardingServiceEnabled'];
                                    scope.allowedEmployeeTransfer = results['onBoardingSettings']['employees_movement_allowed'];
                                    var childSuitableToOfferEnabled = results['isReadyToOfferColumnServiceEnabled'];
                                    scope.childCanManageNotificationEmail = results['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_NOTIFICATION_EMAIL);
                                    var isUKBrand = false;

                                    if (results['documentSets'] && results['documentSets'].document_sets) {
                                        var geoDocSet = _.find(results['documentSets'].document_sets, {category: "GEO"});
                                        if (geoDocSet && (geoDocSet.code === "UK" || geoDocSet.code === "UK_MINIMIZED")) {
                                            isUKBrand = true;
                                        }
                                    }

                                    scope.displayFlows = [
                                        {title: "applicants", mode: "HIRING_PROCESS", id: "APP", code: "APPLICANTS", name: "applicants", shown: true, enabled: true},
                                        {title: "Interview", mode: "HIRING_PROCESS", id: "INTV", code: "INTERVIEW", name: "interview", shown: false, enabled: true},
                                        {title: "Suitable to offer", mode: "HIRING_PROCESS", id: "RTO", code: "READY_TO_OFFER", name: "suitable-to-offer", shown: false, enabled: childSuitableToOfferEnabled},
                                        {title: "offer", mode: "HIRING_PROCESS", id: "OFFR", code: "OFFER", name: "offer", shown: false, enabled: scope.onBoardingServiceEnabled},
                                        {title: "Onboarding", mode: "HIRING_PROCESS", id: "ONBRD", code: "ON_BOARDING", name: "onboarding", shown: false, enabled: scope.onBoardingServiceEnabled},
                                        {title: "Document Builder", mode: "HIRING_PROCESS", id: "DOC_BUILDER", code: "ON_BOARDING_DOCUMENT_BUILDER", name: "document-builder", shown: false, enabled: scope.onBoardingServiceEnabled},
                                        {title: "hire", mode: "HIRING_PROCESS", id: "HIRE", code: "HIRE", name: "hire", shown: false, enabled: true},
                                        {title: "video screening", mode: "HIRING_PROCESS", id: "VIDEO_INTERVIEW", code: "VIDEO_INTERVIEW", name: "video-interview", shown: false, enabled: results['VIDEO_INTERVIEW']},
                                        {title: "Background Check", mode: "HIRING_PROCESS", id: "BACKGROUND_CHECK", code: "BACKGROUND_CHECK", name: "background-check", shown: false, enabled: results['BACKGROUND_CHECK']},
                                        {title: "Food Cert. Exp.", mode: "DOCUMENTS_EXPIRY", id: "FOOD", code: "FOOD_CERTIFICATION", name: "food", shown: true, enabled: scope.childCanManageNotificationEmail},
                                        {title: "Alcohol Cert. Exp.", mode: "DOCUMENTS_EXPIRY", id: "ALCOHOL", code: "ALCOHOL_CERTIFICATION", name: "alcohol", shown: false, enabled: scope.childCanManageNotificationEmail},
                                        {title: "Insurance Registration", mode: "DOCUMENTS_EXPIRY", id: "INSURANCE", code: "INSURANCE_REGISTRATION", name: "insurance", shown: false, enabled: scope.childCanManageNotificationEmail},
                                        {title: "Motor Vehicle Record", mode: "DOCUMENTS_EXPIRY", id: "MOTOR", code: "MOTOR_VEHICLE_RECORD", name: "motor", shown: false, enabled: scope.childCanManageNotificationEmail},
                                        {title: "Driver License Exp.", mode: "DOCUMENTS_EXPIRY", id: "DRIVER", code: "DRIVER_LICENSE", name: "driver", shown: false, enabled: scope.childCanManageNotificationEmail},
                                        {title: "NMC Pin Exp.", mode: "DOCUMENTS_EXPIRY", id: "NMC", code: "NMC_PIN", name: "nmc", shown: false, enabled: scope.childCanManageNotificationEmail},
                                        {title: "I-9 Form Exp.", mode: "DOCUMENTS_EXPIRY", id: "I9", code: "I9", name: "i9", shown: false, enabled: scope.childCanManageNotificationEmail && !isUKBrand},
                                        {title: "RTW Exp.", mode: "DOCUMENTS_EXPIRY", id: "RTW", code: "RTW", name: "rtw", shown: false, enabled: scope.childCanManageNotificationEmail && isUKBrand},
                                        {title: "Hiring of a minor", mode: "DOCUMENTS_EXPIRY", id: "MINOR_HIRING", code: "MINOR_HIRING", name: "MINOR_HIRING", shown: false, enabled: true},
                                        {title: "Termination and Transfer", mode: "TERMINATION_TRANSFER", id: "TERMINATION_TRANSFER", code: "TERMINATION_TRANSFER", name: "TERMINATION_TRANSFER", shown: true, enabled: true},
                                        {title: "Minor Work Documentation", mode: "DOCUMENTS_EXPIRY", id: "MINOR_WORK", code: "MINOR_HIRING", name: "minor work", shown: false, enabled: scope.childCanManageNotificationEmail}
                                    ];

                                    var allCategories = [];
                                    var hirringProcessCategories = [];
                                    var terminationAndTransferCategories = [
                                        {
                                            name: 'Employee Termination',
                                            id: 'TERMINATION',
                                            code: 'TERMINATION',
                                        }
                                    ];

                                    if (scope.allowedEmployeeTransfer) {
                                        terminationAndTransferCategories.push({
                                            name: 'Employee Transfer',
                                            id: 'TRANSFER',
                                            code: 'TRANSFER',
                                        })
                                    }

                                    var activeTab;
                                    scope.setActive = function (type) {
                                        if (activeTab === type) {
                                            return;
                                        }
                                        _.each(scope.displayFlows, function (value, key, list) {
                                            if (scope.activeMode === value.mode) {
                                                value.shown = value.name === type;
                                            }
                                        });
                                        activeTab = type;
                                    };

                                    scope.action = {
                                        action_url: 'brands/' + activeBrandId + '/notification_settings'
                                    };

                                    scope.setActiveMode = function (mode) {
                                        scope.loading = true;
                                        scope.activeMode = bulkObject.mode = mode;

                                        if (scope.activeMode === "HIRING_PROCESS") {
                                            scope.categories = hirringProcessCategories;
                                            scope.data.comm_emails.flows = {APPLICANTS: {}, INTERVIEW: {}, HIRE: {}};
                                            if (scope.onBoardingServiceEnabled) {
                                                scope.data.comm_emails.flows['ON_BOARDING'] = {};
                                                scope.data.comm_emails.flows['OFFER'] = {};
                                                scope.data.comm_emails.flows['ON_BOARDING_DOCUMENT_BUILDER'] = {};
                                            }
                                            if (childSuitableToOfferEnabled) {
                                                scope.data.comm_emails.flows['READY_TO_OFFER'] = {};
                                            }
                                            if (results['VIDEO_INTERVIEW']) {
                                                scope.data.comm_emails.flows['VIDEO_INTERVIEW'] = {};
                                            }
                                            if (results['BACKGROUND_CHECK']) {
                                                scope.data.comm_emails.flows['BACKGROUND_CHECK'] = {};
                                            }
                                        } else if (scope.activeMode === "TERMINATION_TRANSFER") {
                                            scope.categories = terminationAndTransferCategories;
                                            scope.data.comm_emails.flows = {TERMINATION_TRANSFER: {}};
                                        } else {
                                            scope.categories = allCategories;
                                            scope.data.comm_emails.flows = {
                                                FOOD_CERTIFICATION: {},
                                                ALCOHOL_CERTIFICATION: {},
                                                MINOR_HIRING: {},
                                                DRIVER_LICENSE: {},
                                                NMC_PIN: {},
                                                INSURANCE_REGISTRATION: {},
                                                MOTOR_VEHICLE_RECORD: {}
                                            };
                                            if (isUKBrand) {
                                                scope.data.comm_emails.flows['RTW'] = {};
                                            } else {
                                                scope.data.comm_emails.flows['I9'] = {};
                                            }
                                        }

                                        loadActiveModeData();
                                    };

                                    bulkObject.notification_settings = [];

                                    scope.communicationEmailsReset = function () {
                                        scope.data.comm_emails.flows = dataStatus[activeBrandId][scope.activeMode].data;
                                    };

                                    var currentRequestId;

                                    var loadActiveModeData = function () {
                                        if (dataStatus[activeBrandId] && dataStatus[activeBrandId][scope.activeMode].isLoaded || (scope.activeMode === 'DOCUMENTS_EXPIRY' && !scope.childCanManageNotificationEmail)) {
                                            scope.data.comm_emails.flows = angular.copy(dataStatus[activeBrandId][scope.activeMode].data);
                                            scope.loading = false;
                                            return;
                                        }
                                        var requestId = Date.now();
                                        currentRequestId = requestId;
                                        var commEmailsPromise = httpHelper.g('brands/' + activeBrandId + '/notification_settings?mode=' + scope.activeMode);
                                        commEmailsPromise.then(function (res) {
                                            if(requestId === currentRequestId){
                                            if (res.data.data.notification_settings && res.data.data.notification_settings.length) {
                                                var mappedFlows = res.data.data.notification_settings;
                                                for (var i in mappedFlows) {
                                                    var flow = mappedFlows[i].flow;
                                                    if (mappedFlows[i].flow === 'TERMINATION' || mappedFlows[i].flow === 'TRANSFER') {
                                                        mappedFlows[i].flow = 'TERMINATION_TRANSFER'
                                                    }
                                                    if (mappedFlows[i]['categories'] && mappedFlows[i]['categories'].length) {
                                                        for (var x in mappedFlows[i].categories) {
                                                            if (flow === 'TERMINATION') {
                                                                mappedFlows[i].categories[x].code = 'TERMINATION';
                                                            }
                                                            if (flow === 'TRANSFER') {
                                                                mappedFlows[i].categories[x].code = 'TRANSFER';
                                                            }
                                                            if (mappedFlows[i].categories[x]['users'] && mappedFlows[i].categories[x]['users'].length) {
                                                                for (var y in mappedFlows[i].categories[x]['users']) {
                                                                    if (scope.activeMode === "HIRING_PROCESS") {
                                                                        var adminForId = _.findWhere(self.hiring_process_brand_managers, {id: mappedFlows[i]['categories'][x]['users'][y]['id']});
                                                                    } else if (scope.activeMode === "TERMINATION_TRANSFER") {
                                                                        var adminForId = _.findWhere(scope.termination_brand_managers, {id: mappedFlows[i]['categories'][x]['users'][y]['id']});
                                                                    } else {
                                                                        var adminForId = _.findWhere(self.notification_emails_brand_managers, {id: mappedFlows[i]['categories'][x]['users'][y]['id']});
                                                                    }
                                                                    if (scope.data.comm_emails.flows[mappedFlows[i]['flow']]) {
                                                                        if (!scope.data.comm_emails.flows[mappedFlows[i]['flow']][mappedFlows[i]['categories'][x]['code']]) {
                                                                            scope.data.comm_emails.flows[mappedFlows[i]['flow']][mappedFlows[i]['categories'][x]['code']] = [];
                                                                        }
                                                                        if (adminForId) {
                                                                            scope.data.comm_emails.flows[mappedFlows[i]['flow']][mappedFlows[i]['categories'][x]['code']]
                                                                                .push(adminForId);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            } else {
                                                if(scope.activeMode === 'TERMINATION_TRANSFER') {
                                                    for (var i in scope.categories){
                                                        scope.data.comm_emails.flows['TERMINATION_TRANSFER'][scope.categories[i].code] = [];
                                                    }
                                                }
                                            }

                                            dataStatus[activeBrandId][scope.activeMode].isLoaded = true;
                                            dataStatus[activeBrandId][scope.activeMode].data = angular.copy(scope.data.comm_emails.flows);
                                            scope.loading = false;
                                            }
                                        });
                                    };

                                    var promises = {};

                                    promises['categories'] = registrationApi.getCategoriesLookup();

                                    $q.all(promises)
                                        .then(function (res) {
                                            if (res['categories'] && res['categories'].length) {
                                                allCategories = res['categories'] || [];
                                                for (var i in res['categories']) {
                                                    if ($.inArray(res['categories'][i]['code'], categoryCodes) >= 0) {
                                                        hirringProcessCategories.push(res['categories'][i]);
                                                    }
                                                }
                                                hirringProcessCategories.push({code: "OTHER", name: "Other"});
                                            }

                                            self.hiring_process_brand_managers = [];
                                            scope.termination_brand_managers = [];
                                            self.notification_emails_brand_managers = [];

                                            scope.hiring_process_brand_managers_per_category = [];
                                            scope.notification_emails_brand_managers_per_category = [];

                                            brandServices.check(brandServices.SERVICES.E_VERIFY, activeBrandId)
                                                .then(function (hasEVerifyService) {
                                                    var communicationEmailsPermissions = ['MANAGE_JOB_CANDIDATES', 'MANAGE_DOCS_OFFERS_FROM_TEMPLATE', 'MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION', 'MANAGE_DOCS_OFFERS'];
                                                    var manageDocsPermissions = ['MANAGE_DOCS_OFFERS', 'MANAGE_DOCS_OFFERS_FROM_TEMPLATE', 'MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION'];

                                                    if (hasEVerifyService) {
                                                        communicationEmailsPermissions.push('I_9_REVIEW_AND_E_VERIFY');
                                                    }

                                                    adminsUsersService.getLoadAdminUsersPolicy(activeBrandId, communicationEmailsPermissions)
                                                        .then(function (adminUsersPolicy) {
                                                            var adminsWithManageDocsPermissions = adminUsersPolicy.getUnionAdminUsersPerPermission(manageDocsPermissions);
                                                            scope.termination_brand_managers = adminsWithManageDocsPermissions;
                                                            self.hiring_process_brand_managers = adminUsersPolicy.getUnionAdminUsersPerPermission(['MANAGE_JOB_CANDIDATES']);
                                                            scope.hiring_process_brand_managers_per_category = adminUsersPolicy.getAdminUsersPerCategory(self.hiring_process_brand_managers, hirringProcessCategories,['MANAGE_JOB_CANDIDATES']);

                                                            if (hasEVerifyService) {
                                                                var adminsWithI9EVerifyPermission = adminUsersPolicy.getUnionAdminUsersPerPermission(['I_9_REVIEW_AND_E_VERIFY']);
                                                                self.notification_emails_brand_managers = adminsWithManageDocsPermissions.filter(function (item1) {
                                                                    return adminsWithI9EVerifyPermission.some(function (item2) {
                                                                        return item1.id === item2.id;
                                                                    });
                                                                });

                                                                var adminsWithI9EVerifyPerCategory = adminUsersPolicy.getAdminUsersPerCategory(adminsWithI9EVerifyPermission, allCategories, ['I_9_REVIEW_AND_E_VERIFY']);
                                                                var adminsWithI9EVerifyAndManageDocsPerCategory = [];

                                                                for (var cat in adminsWithI9EVerifyPerCategory) {
                                                                    var categoryUsers = adminsWithI9EVerifyPerCategory[cat];
                                                                    for (var i in categoryUsers) {
                                                                        for (var permission in categoryUsers[i].permissions) {
                                                                            var checkPermissionMatch = function () {
                                                                                if (!adminsWithI9EVerifyAndManageDocsPerCategory[cat]) {
                                                                                    adminsWithI9EVerifyAndManageDocsPerCategory[cat] = [];
                                                                                }
                                                                                var found = _.findWhere(adminsWithI9EVerifyAndManageDocsPerCategory[cat], {id: categoryUsers[i].id});
                                                                                if (!found && manageDocsPermissions.includes(categoryUsers[i].permissions[permission].code)) {
                                                                                    adminsWithI9EVerifyAndManageDocsPerCategory[cat].push(categoryUsers[i])
                                                                                }
                                                                            };

                                                                            if (!categoryUsers[i].permissions[permission].is_allowed_all_categories) {
                                                                                for (var j in categoryUsers[i].permissions[permission].categories) {
                                                                                    var categoryCode = categoryUsers[i].permissions[permission].categories[j];
                                                                                    if (categoryCode == cat) {
                                                                                        checkPermissionMatch()
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                checkPermissionMatch()
                                                                            }
                                                                        }
                                                                    }
                                                                }

                                                                scope.notification_emails_brand_managers_per_category = adminsWithI9EVerifyAndManageDocsPerCategory;
                                                            } else {
                                                                self.notification_emails_brand_managers = adminsWithManageDocsPermissions;
                                                                scope.notification_emails_brand_managers_per_category = adminUsersPolicy.getAdminUsersPerCategory(self.notification_emails_brand_managers, allCategories, manageDocsPermissions);
                                                            }
                                                        })
                                                        .catch(function (err) {
                                                            console.error(err);
                                                        })
                                                        .finally(function () {
                                                            scope.setActiveMode('HIRING_PROCESS');
                                                        });
                                                });
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                        });
                                })
                                .catch(function (err) {
                                    console.error(err);
                                })
                                .finally(function () {
                                    return promisesList;
                                });
                        },
                        beforeSave: function (formData, valid) {
                            for (var i in formData.flows) {
                                // keys = APPLICANTS ... (has keys of position groups)
                                var flowObject = {
                                    "flow": i,
                                    "categories": []
                                };
                                for (var x in formData.flows[i]) {
                                    // keys = FOH, BOH, ... (these are arrays with user ids)
                                    if (formData.flows[i][x] && formData.flows[i][x].length) {
                                        var users = formData.flows[i][x].map(function (value) {
                                            return value.id;
                                        });
                                        var cat = {
                                            "users": users
                                        };
                                        if (x != "OTHER") {
                                            var category = _.findWhere(scope.categories, {code: x});

                                            if (category) {
                                                cat['id'] = category['id'];
                                                flowObject.categories.push(cat);
                                            }
                                        }
                                        else {
                                            flowObject.categories.push(cat);
                                        }
                                    }
                                }
                                bulkObject.notification_settings.push(flowObject);
                            }

                            if (bulkObject.mode === 'TERMINATION_TRANSFER') {
                                var terminationAndTransferNotification = [];
                                for (var i in bulkObject.notification_settings) {
                                    if (bulkObject.notification_settings[i].flow === 'TERMINATION_TRANSFER') {
                                        var categories = bulkObject.notification_settings[i].categories;
                                        for (var categoryCode in categories) {
                                            var category = categories[categoryCode];
                                            terminationAndTransferNotification.push({
                                                flow: category.id,
                                                categories: [category]
                                            });
                                            delete category.id;
                                        }
                                        if (!categories.length) {
                                            for (var i in formData.flows) {
                                                for (var flowCode in formData.flows[i]) {
                                                    terminationAndTransferNotification.push({
                                                        "flow": flowCode,
                                                        "categories": []
                                                    });
                                                }
                                            }
                                        }
                                        bulkObject.notification_settings = terminationAndTransferNotification;
                                        break;
                                    }
                                }
                            }
                            return bulkObject;
                        },
                        afterSave: function (data, formData, requestStatus) {
                            if (data.status_code == 400 && data.data.code == "USER_DOES_NOT_HAVE_REQUIRED_PERMISSIONS") {
                                $modal({
                                    controller: 'SomethingWentWrongModal',
                                    controllerAs: '$ctrl',
                                    templateUrl: '../modules/settings/modals/something-went-wrong/something-went-wrong.modal.html',
                                    show: true,
                                    backdrop: 'static',
                                    keyboard: false,
                                    resolve: {
                                        modalData: function () {
                                            return {
                                                brandId: activeBrandId,
                                            };
                                        }
                                    }
                                });
                            }

                            if (data.status_code == 200) {
                                dataStatus[activeBrandId][scope.activeMode].isLoaded = false;
                                scope.$emit("brandSettingsNavigation.next");
                            }
                            if (data.status == "Error") {
                                hAlert("Error", $filter("translate")(data.data[0].error));
                            }
                        }
                    }).then(function (formObj) {

                    })

                }
            }
        }]);

/* ==================================================================*/
/* Talent Acquisition Engagement Settings - On Boarding Journey Events
 /* =================================================================*/

app.directive('engagementSettingsDirective',
    ["userPermissions", "hFormReference", "$stateParams", "settingsFactory", "brandServices", 'hUser',
    function (userPermissions, hFormReference, $stateParams, settingsFactory, brandServices, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.canManageOnBoardingJourney = false;
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        var promises = {
                            policyParser: userPermissions.getBrandPolicy(scope.brandId),
                            isOnboardingJourneyServiceEnabled: brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, scope.brandId)
                        };
                        $q.all(promises)
                            .then(function (results) {
                                var isOnboardingJourneyServiceEnabled = results['isOnboardingJourneyServiceEnabled'];
                                var canManageOnBoardingJourneyTemplates = results['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_ON_BOARDING_JOURNEY_EVENTS);
                                scope.canManageOnBoardingJourney = isOnboardingJourneyServiceEnabled && canManageOnBoardingJourneyTemplates;
                            });
                    },
                });
            }
        }
    }]);

/* =============================================================*/
/* Brand Notification Receipt Settings
 /* =============================================================*/

app.directive('brandNotificationReceiptSettingsDirective',
    ["userPermissions", "hFormReference", "hUser", "settingsFactory",
        function (userPermissions, hFormReference, hUser, settingsFactory) {
            return {
                link: function (scope, element) {
                    hFormReference.current(element, {
                        beforeDeactivate: function (scope) {
                        },
                        beforeActive: function (scope) {
                            scope.brandId = hUser.getActiveBrandIdWithAccess();
                            scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        },
                    });
                }
            }
        }]);

/* =====================================================*/
/* Documents Default Fields
/* =====================================================*/
app.directive('documentsDefaultFieldsDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'userPermissions',
    'documentsDefaultFieldsService',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, userPermissions, documentsDefaultFieldsService, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.documentsDefaultFieldsActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);

                        scope.isHighestParent = scope.activeBrand.id === scope.activeBrand.group_id;

                        if (scope.activeBrand) {
                            documentsDefaultFieldsService.canManageDefaultFieldsSettings(scope.activeBrand.id)
                                .then(function (canManageDefaultFields) {
                                    scope.documentsDefaultFieldsActive = canManageDefaultFields;
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });
                        }
                    },
                });
            }
        }
    }]);

/* =============================================================*/
/* Minimum Minor Age
/* =============================================================*/
app.directive('minimumMinorAgeDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    'userPermissions',
    'brandServices',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, userPermissions, brandServices, hUser) {
        return {
            link: function (scope, element) {
                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.minimumMinorAgeActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                        scope.isHighestParent = scope.activeBrand.id === scope.activeBrand.group_id;

                        if (scope.activeBrand) {
                                var defer = $q.defer();
                                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                brandServices.check(brandServices.SERVICES.MINOR_HANDLING, activeBrandId)
                                    .then(function (isMinorsHandlingServiceEnabled) {
                                        if (isMinorsHandlingServiceEnabled) {
                                            MinimumMinorAgeAPI.minorHandlingSettingsEnabled(activeBrandId)
                                                .then(function (res) {
                                                    scope.minimumMinorAgeActive = res.minor_minimum_age_restriction_enabled;
                                                    defer.resolve();
                                                })
                                                .catch(function (err) {
                                                    console.error(err);
                                                    defer.resolve();
                                                });
                                        } else {
                                            scope.minimumMinorAgeActive = false;
                                            defer.resolve();
                                        }
                                    });
                                return defer.promise;
                        }
                    },
                });
            }
        }
    }]);

/* =============================================================*/
/* Brand Locations Settings
/* =============================================================*/
app.directive('brandLocationsDirective', ["$q", "httpHelper", "hFormReference", "$state", "$filter", "hUser", "settingsFactory", "$rootScope", function($q,httpHelper, hFormReference, $state, $filter, hUser, settingsFactory,$rootScope) {
  return {
    link: function(scope, element) {

      // Initial data, used to reset the form (discard changes)
      var remoteBrandLocations;

      // Move to next settings form after complete
      scope.brandLocationsCompleted = function() {

          //$state.go('settings.brandSection', {view:'job_templates', brand_id: scope.data.brand_loc.brand_id});
        scope.$emit("brandSettingsNavigation.next");
      };

      // Reset the form with initial loaded values
      scope.brandLocationsReset = function() {
          scope.reset();
          scope.data.brand_loc.brand_location = remoteBrandLocations;
      };

      // Delete location non-effective until save is clicked
      scope.brandLocationsDelete = function(index) {
        /* get location from the array */
        var locationObject = scope.data.brand_loc.brand_location[index];

        /* used in confirm delete */
        var locationTitle = locationObject.Location.formatted_address ? locationObject.Location.formatted_address : locationObject.Location.label;
        /* used in delete request */
        var locationId    = locationObject.Location.id;

        //confirm before save
        hConfirm($filter("escape")($filter("translate")("Are you sure you want to delete")+" '"+locationTitle+"' "+$filter("translate")("location?")), function(result) {
          if(result) {
            var promise = httpHelper.g("brand/delete_location/"+locationId);

            promise.then(function (result){
              if(result && result.data && result.data.status_code){
                if(result.data.status_code == 200){
                  scope.data.brand_loc.brand_location.splice(index, 1);
                }else{
                  hAlert($filter("translate")("Error!"), result.data.data);
                }
              }else{
                hAlert($filter("translate")("Error!"),$filter("translate")("something wrong happened, please try again at a later time."));
              }
            });

          }
        });
      };

      /*
      * watch the brand locations, when updated (a new location is added,
      * check the array and send the new one over the API
      */

      scope.$watch('data.brand_loc.brand_location', function(newValue, oldValue){


        //only works when there is a new value addeds
        if (!newValue || newValue.length == 0 || (newValue && oldValue && newValue.length <= oldValue.length)) {
          return;
        }

        // loop over the array and find the new location
        for(var i in scope.data.brand_loc.brand_location){

          //chec if it's from google location and not already saved
          if (scope.data.brand_loc.brand_location[i].value && !scope.data.brand_loc.brand_location[i].saved) {
            //build request data sent to API
            var dataObj = {};
            dataObj.brand_id = scope.data.brand_loc.brand_id;
            dataObj.google_location = scope.data.brand_loc.brand_location[i].value;
            //mark as saved
            scope.data.brand_loc.brand_location[i].saved = true;
            //request to API
            var promise = httpHelper.put("brand/location", dataObj);
            promise.then(function(result){
              //check if it was saved otherwise delete the location from the array which shown on the view
              //and alert the response to user
              if(result && result.data && result.data.status_code == 200){
                  //check if the API returned the location object with an ID, otherwise alert and error
                  //and delete it from the array
                  if(result.data.data && result.data.data.length > 0 && result.data.data[0].Location &&  scope.data.brand_loc.brand_location[i]) {
                    scope.data.brand_loc.brand_location[i].Location = result.data.data[0].Location;
                  }else{
                    hAlert($filter("translate")("Error!"), $filter("translate")("we couldn't save this location, please try again at a later time"));
                    //delete the location user added
                    ar_delete(scope.data.brand_loc.brand_location, i);
                  }
              }else{
                  hAlert($filter("translate")("Error!"), result.data.data);
                  //delete the location user added
                  ar_delete(scope.data.brand_loc.brand_location, i);
              }
            });

          }
        }

      }, true);


      hFormReference.current(element, {
        beforeActive: function(scope) {

          scope.data.brand_loc.brand_id = $state.params.brand_id;
          var promise = httpHelper.g("brand/location/" + scope.data.brand_loc.brand_id);
          promise.then(function(res) {

              // Update location coming from API to have label used to avoid duplicate in locations hSelect
              for (var i in res.data.data) {
                res.data.data[i].label = res.data.data[i].Location.formatted_address;
                res.data.data[i].saved = true;
              }

              scope.data.brand_loc.brand_location = res.data.data;
              remoteBrandLocations = scope.data.brand_loc.brand_location;

          });

          return promise;
        },
        beforeSave: function(formData, valid) {
        }
      }).then(function(formObj) {
      })

    }
  }
}]);


//Reviews Reminder Directive
app.directive('reviewsDirective', ["hFormReference", "$state", "hUser", function(hFormReference, $state, hUser) {
    return {

        link: function(scope, element) {

            var orginalData = {};
            const activeBrandId = hUser.getActiveBrandIdWithAccess();
            scope.reviewsComplete = function() {
                scope.$emit("brandSettingsNavigation.next");
            };

            scope.reviewsReset= function() {
                //reset form
                scope.reset();
                //return the saved requst
                var formData = angular.copy(orginalData);
                scope.data.reviews_settings.reviewPeriod = formData.period || 'THREE_MONTHS';
                scope.data.reviews_settings.recuring = formData.recurring || false;
                scope.data.reviews_settings.reviewDueReminder = formData.reminder_enabled || false;
            };

            hFormReference.current(element, {
                beforeActive: function(scope) {

                    //Load brand id into the view
                    scope.data.reviews_settings.brand_id = activeBrandId;

                    var defer = $q.defer();

                    SettingsAPI.getBrandReviewsSettings(activeBrandId).then(function(res) {

                        //save data for reset
                        orginalData = angular.copy(res);

                        //bind data to form
                        scope.data.reviews_settings.reviewPeriod = res.period || 'THREE_MONTHS';
                        scope.data.reviews_settings.recuring = res.recurring || false;
                        scope.data.reviews_settings.reviewDueReminder = res.reminder_enabled || false;

                        defer.resolve();
                    });


                    return defer.promise;
                },
                beforeSave: function(formData, valid) {

                }
            }).then(function(formObj) {

            })

        }
    }
}]);

app.directive('brandRejectionTemplatesDirective', [
    '$stateParams',
    'settingsFactory',
    'hFormReference',
    '$alert',
    'userServices',
    'hUser',
    function ($stateParams, settingsFactory, hFormReference, $alert, userServices, hUser) {
        return {
            link: function (scope, element) {

                hFormReference.current(element, {
                    beforeDeactivate: function (scope) {
                        scope.rejectionTemplateActive = false;
                        scope.$evalAsync();
                    },
                    beforeActive: function (scope) {
                        scope.brandId = hUser.getActiveBrandIdWithAccess();
                        var hasRejectionServicePromise = userServices.isServiceEnabled(userServices.SERVICES.REJECTION_TEMPLATES, scope.brandId );

                        hasRejectionServicePromise.then(function (hasRejectionService) {
                            if (hasRejectionService) {
                                scope.activeBrand = hUser.data.user.brands_list.find((brand) => brand.id === scope.brandId);
                                scope.rejectionTemplateActive = true;
                            }
                        });


                    }
                });
            }
        }
    }
]);

app.directive('carriSettingsDirective',
    ['hUser', '$q', 'hFormReference', 'settingsFactory', 'brandServices', 'hFormsService', 'chatBotService',
        function (hUser, $q, hFormReference, settingsFactory, brandServices, hFormsService, chatBotService) {
            return {

                link: function ($scope, element) {
                    hFormReference.current(element, {
                        beforeActive: function (scope) {

                            $scope.activeBrand = hUser.data.user.brands_list.find(function (brand) {
                                return brand.id === hUser.getActiveBrandIdWithAccess();
                            });

                            if ($scope.activeBrand) {
                                brandServices.check(brandServices.SERVICES.CARRI_CHATBOT, $scope.activeBrand.id)
                                    .then(function (isCarriServiceEnabled) {
                                        if (isCarriServiceEnabled) {
                                            chatBotService.isCarriChatBotOwner($scope.activeBrand.id)
                                                .then(function (isOwner) {
                                                    if (isOwner) {
                                                        $scope.isCarriChatBotOwner = true;
                                                        var carriSettingsForm = hFormsService.getForm("carriSettingsForm");
                                                        $scope.carriSettingsForm = new carriSettingsForm($scope, 'hmap-carri-settings-form');
                                                        $scope.carriSettingsForm.load($scope.activeBrand.id);
                                                    }
                                                })
                                                .catch(function (err) {
                                                    console.error(err);
                                                });
                                        }
                                    });
                            }
                        }
                    });
                }
            }
        }]);

app.directive('manageEeoFormsDirective',
    ['$stateParams', '$q', 'hFormReference', 'settingsFactory', 'eeoDataService', '$state', 'hFormsService', 'userServices', 'userPermissions', 'hUser',
        function ($stateParams, $q, hFormReference, settingsFactory, eeoDataService, $state, hFormsService, userServices, userPermissions, hUser) {
            return {
                link: function ($scope, element) {
                    const eeoQuestionsSettingsForm = hFormsService.getForm("HmapEeoQuestionsSettingsForm");

                    hFormReference.current(element, {
                        beforeActive: function (scope) {

                            var formData = {
                                brandId: hUser.getActiveBrandIdWithAccess()
                            };

                            $scope.activeBrand = hUser.data.user.brands_list.find(function (brand) {
                                return brand.id === hUser.getActiveBrandIdWithAccess();
                            });

                            if ($scope.activeBrand) {
                                const promises = {};
                                promises['policyParser'] = userPermissions.getBrandPolicy($scope.activeBrand.id);
                                promises['eeo_report'] = userServices.isServiceEnabled(userServices.SERVICES.EEO_REPORT, $scope.activeBrand.id);
                                promises['equal_employment_opportunity'] = userServices.isServiceEnabled(userServices.SERVICES.EQUAL_EMPLOYMENT_OPPORTUNITY, $scope.activeBrand.id);

                                $q.all(promises)
                                    .then((response) => {
                                        $scope.isEEOServiceEnabled = response['eeo_report'];
                                        const isEqualEmploymentOpportunityEnabled = response['equal_employment_opportunity'];
                                        const canManageEEOQuestions = response['policyParser'].has(userPermissions.PERMISSIONS.MANAGE_EQUAL_EMPLOYMENT_OPPORTUNITY_QUESTIONS);

                                        if ($scope.isEEOServiceEnabled) {

                                            formData.brandId = $scope.activeBrand.id;

                                            $scope.manageEEOFormsForm = $scope.manageEEOFormsForm || new ManageEEOFormsForm($scope, eeoDataService, $q, $state);
                                            $scope.manageEEOFormsForm.load(formData.brandId);
                                        } else if (isEqualEmploymentOpportunityEnabled && canManageEEOQuestions) {
                                            $scope.isEqualEmploymentOpportunityServiceEnabled = true;
                                            $scope.eeoQuestionsSettingsForm = new eeoQuestionsSettingsForm($scope, 'hmap-eeo-questions-settings-form');
                                            $scope.eeoQuestionsSettingsForm.load(formData.brandId);
                                        }
                                    })
                            }
                        },
                        beforeDeactivate: function () {
                            delete $scope.isEqualEmploymentOpportunityServiceEnabled;
                            delete $scope.eeoQuestionsSettingsForm;
                        }
                    });
                }
            }
        }]);
